window.dataLayer = window.dataLayer || [];

window.onload = function () {
	jQuery('.preloader:not(".loaded")').addClass('loaded');
	jQuery('.overhid').removeClass('overhid');
};

//disable fancybox hash
$.fancybox.defaults.hash = false;
$.fancybox.defaults.animationEffect = 'fade';

//jQuery(document).ready(function ($) {
$(document).ready(function(){

	// var options = {
	// 	animateThreshold: 10, //сколько пикселей блока д.б. видно, чтобы началась анимация
	// 	scrollPollInterval: 0
	// }
	// $('.foranimate').AniView(options);

	contactform_file_upload();

	var app = {

        yandexMapsScriptUrl: 'https://api-maps.yandex.ru/2.1/?lang=ru_RU&apikey=8859bbcc-6c02-4f60-ba9a-e3345e0f3421',
        yandexMapsYMAPS: null,

        cdekWidgetScriptUrl: '/templates/itp/cdek/widjet.js',
        ISDEKWidjet: null,

        deliveryPickupInitialised: false,
        deliveryCourierInitialised: false,
        deliveryCdekInitialised: false,

		initialize: function(){
			this.setUpListners();
		},

		setUpListners: function(){

			$(document).on('submit', '#js_shop_filter', app.filterItems);
			// $(document).on('change', '#js_shop_filter label, #js_shop_filter select, #js_shop_filter input', app.floatSubmitButton);
			$(document).on('change', '#js_shop_filter label, #js_shop_filter select, #js_shop_filter input', app.filterItems);
			$(document).on('click', '#js_sortrow a', app.sortItems);
			$(document).on('click', '.js_shop_items_list #js_pagenavigation a', app.standartPagination); //использую только на странице каталога товаров
			$(document).on('click', '#js_morenav', app.morenavPagination);
			$(document).on('click', '#js-articles-list__more-btn', app.contentMorePagination);
			$(document).on('click', '#js-feedbacks-list__more-btn', app.feedbackMorePagination);
			$(document).on('click', '#js-feedbacks-list__more-btn_page-item', app.feedbackShopItemMorePagination);

			$(document).on('click', '.js-shop-hits-list-item__link', app.hitsListItemLinkClick);
			$(document).on('click', '.js-shop-list-item__link', app.listItemLinkClick);
			$(document).on('click', '.js-main-slider-slide__item-link', app.mainSliderItemLinkClick);

			$(document).on('click', '.js-region-honey', app.geographySvgHoneyRegionClick);

			$(document).on('click', '#js-store-select__marker', app.headerStoresSelectMarkerClick);
			$(document).on('click', '#js-navbar-search__magnifier', app.navbarSearchMagnifierClick);

			// $(document).on('click', '.shop-categories-toggler', app.mainMenuCatalogTogglesClick);

			$(document).on('click', '.js-shop-tags-letters-item', app.tagsLetterClick);
			$(document).on('click', '.js-shop-subcats-letters-item', app.subcatsLetterClick);
			$(document).on('click', '.js-shop-vendors-letters-item', app.vendorsLetterClick);

			$(document).on('click', '[data-target="#main-nav"]', app.navbarToggleClick);

			$(document).on('submit', 'form.js_addtocart_list', app.addtocartItemsList);
			$(document).on('submit', '#js_addtocart_itempage', app.addtocartItemPage);

			$(document).on('click', '#js_shop-item-page__btn_cancel', app.cancelCartItemPage);

			$(document).on('mouseenter', '.js-feedback-rating__star', app.feedbackStarMouseEnter);
			$(document).on('mouseleave', '.js-feedback-rating__star', app.feedbackStarMouseLeave);
			$(document).on('click', '.js-feedback-rating__star', app.feedbackStarClick);

			$(document).on('click', '.js-shop-item-page-images__img-wrap', app.itemImagesImgWrapClick);

			$(document).on('click', '.js-shop-list-item-var-select', app.itemsListChangeVarSelect);

			$(document).on('submit', '#js_feedback_add', app.feedbackAdd);
			$(document).on('keydown', '#js_feedback_add .form-control', app.formsRemoveError);
			$(document).on('click', '.js_feedback_rating', app.feedbackRating);

			$(document).on('submit', '#js-shop-item-page-feedback-form', app.feedbackShopItemAdd);
			$(document).on('keydown', '#js-shop-item-page-feedback-form .form-control', app.formsRemoveError);
			$(document).on('click', '#js-shop-item-page__rating-text-col', app.setFeedbacksVisible);

			$(document).on('submit', '#js-order-comment-add-form', app.orderCommentAdd);
			$(document).on('keydown', '#js-order-comment-add-form .form-control', app.formsRemoveError);

			$(document).on('submit', '#js-shop-quick-order__form', app.quickOrderSubmit);
			$(document).on('keydown input', '#js-shop-quick-order__form .form-control', app.formsRemoveError);

			$(document).on('submit', '#js_realdiscountcard_save', app.realdiscountcardSave);
            $(document).on('keydown input', '#js_realdiscountcard_save .form-control', app.formsRemoveError);

			$(document).on('click', '#js-shop-order__discount-card-btn', app.orderSaveDiscountCardClick);

			$(document).on('submit', '#js_speedbuy', app.speedBuy);
			$(document).on('show.bs.modal', '#js_speedbuyinfo', app.speedBuyBeforeModal); //при быстром заказе из блока с характеристиками из простых характеристик (не влияющих на цену) берутся выбранные значения
			$(document).on('show.bs.modal', '#js_pre_order_modal', app.preOrderBeforeModal);
			$(document).on('click', '#js_speedbtn', app.speedBuyBtnClick);

			$(document).on('mouseover',  '.has-popover', function(){ $(this).popover('show'); });
			$(document).on('mouseleave', '.has-popover', function(){ $(this).popover('hide'); });

			$(document).on('click', '#js_cart_form .js_qty_wrapper .js_qtylink', app.cartQTYchange);
			$(document).on('change', '#js_cart_form .js_qty_wrapper .js_qty_input', app.cartQTYchange);
			$(document).on('click', '#js_cart_form .js_cartitem_delete', app.cartDeleteItem);
			$(document).on('click', '#js_coupon_submit', app.cartApplyCoupon);
			$(document).on('click', '#js_bonuses_submit', app.cartApplyBonuses);

			$(document).on('click', '#js-shop-order__promo-code-btn', app.orderApplyPromoCode);


			$(document).on('click', '.js_addtocart_list .js_qtylink', app.itemsListQTYchange);
			$(document).on('change', '.js_addtocart_list .js_item_addqty', app.itemsListQTYchange);

			$(document).on('click', '#js_shop_item_page .js_qty_wrapper .js_qtylink', app.itemPageQTYchange);
			$(document).on('change', '#js_shop_item_page .js_qty_wrapper input', app.itemPageQTYchange);
			$(document).on('click', '#js_shop_item_page .js_changed_char .js_label', app.itemChangeVars);

			$(document).on('click', '.js-shop-stores__text-btn', app.shopStoresTextButtonClick);
			$(document).on('click', '.js-shop-order__pickup-link', app.shopOrderPickupLinkClick);
			$(document).on('click', '.js-shop-stores__tab-btn', app.shopStoresTabButtonClick);

			$(document).on('input', '.js-delivery_date_input', app.shopOrderDeliveryDateSelect);
			$(document).on('input', '.js-delivery_time_input', app.shopOrderDeliveryTimeSelect);

			$(document).on('click', '.js_cities .current_city a', function(e){
				e.preventDefault();

				var THIS = $(this),
						WRAP = THIS.parent().parent();

				$('.list', WRAP).slideToggle();
			});

			$(document).on('click', '.js_cities .list button', function(e){
				e.preventDefault();

				var THIS = $(this),
						CITY_TITLE = THIS.html(),
						CITY_ID = THIS.attr('data-cityid'),
						WRAP = THIS.parent().parent().parent();

				$('.current_city a', WRAP).html(CITY_TITLE);
				$('.list', WRAP).slideToggle();

				$.cookie('CMS[city]', CITY_ID, { expires: 30, path: '/'});

				getContent(window.location.href, false);
			});

			//$('#tabNavigation a').on('click', function (e){ e.preventDefault(); $(this).tab('show'); });
			$(document).on('click', '#userorders .panel-heading', function (){ $(this).next().children('.items').toggle(); }); //Страница заказов пользователя - скрытие/показ инфы о заказе

			$(document).on('click', '#xs-search-title', function (){ $(this).next().toggle(); });

			//$('#headerusermenu .modulebodyshow').on('click', function (){ e.preventDefault(); $(this).parent().find('.modulebody').toggle(); });

			$(document).on('submit', 'form.js_formneedtest', app.formsSubmit);
			$(document).on('submit', 'form.js_contactform', app.formsContactSubmit);
			$(document).on('keydown input', 'form.js_formneedtest .form-control, form.js_contactform .form-control', app.formsRemoveError);
			$(document).on('click', 'form.js_formneedtest .custom-control-input, form.js_contactform .custom-control-input', app.formsRemoveError);

			$(document).on('click', '#js_register_submit_button', app.registrationFormSubmitBtnClick);

			$(document).on('click', '.js-shop-order__city', app.deliveryCityRadioClick);

			$(document).on('submit', '#js-order-form', app.orderSubmitFinish);
            $(document).on('keydown input', '#js-order-form .form-control', app.formsRemoveError);
            $(document).on('click keydown input', '#js-order-form input', app.toggleSubmitButtonActiveState);
			// $(document).on('click', '#js-order-form #delivery_type_submit', app.orderDeliverySubmit); // отключил, не используется
			// $(document).on('click', '#js-order-form #contactdata_submit', app.orderContactSubmit); // отключил, не используется
			// $(document).on('click', '#js-order-form .toggleorg', app.orderToggleOrg); // отключил, не используется

			$(document).on('show.bs.collapse', '#collapseOne', app.collapseOneShow);
			$(document).on('show.bs.collapse', '#collapseTwo', app.collapseTwoShow);
			$(document).on('show.bs.collapse', '#collapseThree', app.collapseThreeShow);

			$(document).on('click', '#js_delivery_types .js_d_type', app.orderCalcSummAfterDelivery);
			$(document).on('click', '#js_payment_methods .js_pay_type', app.orderCalcSummAfterPayment);

			$(document).on('click', '#js-shop-order__post-delivery-calc-btn', app.orderCalcPostDeliveryCost);

			$(document).on('click', '.js_filter_block_title', function(){ $(this).next().toggle().parent().toggleClass('is-collapse');});

			$(document).on('click', '.js_compare_add', app.compareAddingItem);
			$(document).on('click', '.js_compare_del', app.compareDelItem);

			$(document).on('click', '.js_bookmark_add', app.bookmarksAddItem);
			$(document).on('click', '.js_bookmark_del', app.bookmarksDelItem);

			$(document).on('submit', '#js_subscribe_add', app.subscribeAdd);
            $(document).on('keydown input', '#js_subscribe_add .form-control', app.formsRemoveError);

			$(document).on('keyup', '.js_searchinput', app.searchSmart);

			//$(document).on('click', 'a:not(.dropdown-toggle)', app.ajaxLinks);

			$(document).on('click', '.js_d_type', app.selectDeliveryType); // при выборе способа доставки
			$(document).on('click', '.js_pay_type', app.selectPsysType); // при выборе способа оплаты
			$(document).on('click', '#js_pickpoint_select', app.selectPickPoint); // при нажатии на Выбрать PickPoint

			$(document).on('change', '#js_select_docs', app.changeSelectDocs); // подбор документов - изменение селекта

			$(document).on('click', '#js-feedback-form-toggle-btn', app.feedbackFormToggleBtnClick);

            $(document).on('click', '.js-anchor-link', app.anchorLinkClick);

            $(document).on('click', '#js_shop-order__delivery-cdek-map button', function (e) {
                e.preventDefault();
            });

            $(window).on('scroll', app.windowScrollHeaderFixed);
            $(window).on('scroll', app.windowScrollNavbarShadow);

            var orderSubmitFixing = $('#js-shop-order__submit-fixing');
            if(orderSubmitFixing.length) {
                app.windowScrollOrderSubmitFixing();
                $(window).on('scroll', app.windowScrollOrderSubmitFixing);
            }

            var shopItemButtonsFixing = $('#js_shop-item-page__btns-fixing');
            if(shopItemButtonsFixing.length && $(window).width()<768) {
                app.handleShopItemPageButtons();
                $(window).on('scroll', app.handleShopItemPageButtons);
            }

            if(window.location.hash === '#js_feedback_add') {
                app.feedbackFormToggle();
                app.anchorLinkMove('#js_feedback_add', '#customer-feedback');
            }

        },

        resetDeliveryTypesInitialised: function() {
            app.deliveryPickupInitialised = false;
            app.deliveryCourierInitialised = false;
            app.deliveryCdekInitialised = false;
        },

        clickOnFirstDeliveryType: function() {

		    // если нет выбранного способа доставки
		    if ( !$('.js_d_type:checked').length ) {

                // клик по первому доступному способу доставки
                $('.js_d_type:not(:disabled)').eq(0).trigger('click');
            }

		    // включаем/выключаем кнопку забмита на всякий случай.
		    app.toggleSubmitButtonActiveState();

        },

        windowScrollNavbarShadow: function() {
            var windowScrollTop = $(window).scrollTop(),
                navbar = $('#js-navbar');

            navbar.toggleClass('navbar_with-shadow', windowScrollTop > 0);
        },

        windowScrollHeaderFixed: function() {
            var windowScrollTop = $(window).scrollTop(),
                headerFixed = $('#js-header-fixed');

            if(headerFixed.length) {

                if ($(window).width() >= 1000 && windowScrollTop > 300) {
                    if(!headerFixed.is('.shown')) {
                        headerFixed.addClass('shown');
                        headerFixed.stop(true, true).fadeIn();
                    }
                } else {

                    if(headerFixed.is('.shown')) {
                        headerFixed.removeClass('shown');
                        headerFixed.stop(true, true).fadeOut('fast');
                    }
                }
            }
        },

        windowScrollOrderSubmitFixing: function() {
            var orderSubmitFixing = $('#js-shop-order__submit-fixing');

            var windowScrollTop = $(window).scrollTop(),
                windowHeight = $(window).height(),
                orderSubmitFixingHeight = orderSubmitFixing.outerHeight(),
                orderSubmit = $('#js-shop-order__submit'),
                orderSubmitHeight = orderSubmit.outerHeight(),
                orderSubmitOffsetTop = orderSubmit.offset().top
            ;

            if (windowScrollTop + windowHeight <= orderSubmitHeight + orderSubmitOffsetTop) {
                orderSubmit.css('height', orderSubmitFixingHeight); // чтобы сохранить высоту страницы неизменной
                orderSubmitFixing.addClass('fixed');
            } else {
                orderSubmitFixing.removeClass('fixed');
                orderSubmit.css('height', 'auto');
            }
        },

        handleShopItemPageButtons: function() {
            var buttons = $('#js_shop-item-page__btns-fixing');

            var windowScrollTop = $(window).scrollTop(),
                // windowHeight = $(window).height(), // не учитывает мобильный хром, панель которого сжирает высоту размер
                windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
                buttonsHeight = buttons.outerHeight(),
                buttonsWrapper = $('#js_shop-item-page__btns-wrapper'),
                buttonsWrapperHeight = buttonsWrapper.outerHeight(),
                buttonsWrapperOffsetTop = buttonsWrapper.offset().top
            ;

            if (windowScrollTop + windowHeight <= buttonsWrapperHeight + buttonsWrapperOffsetTop) {
                buttonsWrapper.css('height', buttonsHeight); // чтобы сохранить высоту страницы неизменной
                buttons.addClass('fixed');
            } else {
                buttons.removeClass('fixed');
                buttonsWrapper.css('height', 'auto');
            }
        },

        headerStoresSelectMarkerClick: function(e) {
		    e.preventDefault();

		    // var block = $('#js-store-select__block');
            // block.toggleClass('show');

            var navbar = $('#js-navbar'),
            openedBlock = navbar.attr('data-opened-block');

            navbar.attr('data-opened-block', openedBlock === 'stores' ? '' : 'stores');

            // $('#js-navbar-search__block').toggleClass('show');

        },

        navbarSearchMagnifierClick: function(e) {
		    e.preventDefault();

		    // var block = $('#js-navbar-search__block');
            // block.toggleClass('show');

            var navbar = $('#js-navbar'),
                openedBlock = navbar.attr('data-opened-block');

            navbar.attr('data-opened-block', openedBlock === 'search' ? '' : 'search');

            // $('#js-store-select__block').removeClass('show');

        },

        geographySvgHoneyRegionClick: function() {
		    var path = $(this),
                vendorId = parseInt( path.attr('data-vendor-id'), 10);

		    window.location.href = "/katalog/med.html?filter[8][]="+vendorId;

        },

        mainMenuCatalogTogglesClick: function(e) {

            var navItem = $(this),
                catalogSubmenu = $('.js-navbar-catalog-submenu');

		    if(catalogSubmenu.length && $(window).width() >= 1000) {
                e.preventDefault();

                navItem.toggleClass('opened');
                catalogSubmenu.stop(true, true).slideToggle();
            }

        },

        tagsLetterClick: function(e){

            var btn = $(this),
                letter = btn.attr('data-letter'),
                listWrapper = $('#js-shop-list-by-letters_tags');

            // loader.show();

            // отключаем другие активные буквы, если они есть
            $('.js-shop-tags-letters-item.active').removeClass('active');

            btn.addClass('active');

            listWrapper.addClass('shop-list-by-letters_one-letter');

            listWrapper
                .find('.js-shop-list-by-letters-item[data-letter='+letter+']').show()
                .siblings().hide();

            // реализация через аякс запросы при клике на букву. убрал, т.к. можно без этого
            // $.ajax({
            //     type: 'get',
            //     url: '/core/ajax/get_tags_for_letter.php',
            //     data: {letter: letter},
            //     dataType: 'json',
            //     success: function (data) {
            //
            //         if (data.success) {
            //             $('#js-shop-list-by-letters_tags').replaceWith( $(data.html) );
            //         } else if (data.message) {
            //             console.log(data.message);
            //         }
            //     },
            //     complete: function(){
            //         loader.hide();
            //     }
            // });

        },

        subcatsLetterClick: function(e){

            var btn = $(this),
                letter = btn.attr('data-letter'),
                listWrapper = $('#js-shop-list-by-letters_subcats');

            // loader.show();

            // отключаем другие активные буквы, если они есть
            $('.js-shop-subcats-letters-item.active').removeClass('active');

            btn.addClass('active');

            listWrapper.addClass('shop-list-by-letters_one-letter');

            listWrapper.find('.js-shop-list-by-letters-item').hide();
            listWrapper.find('.js-shop-list-by-letters-item[data-letter='+letter+']').show();

            $('.js_shop_items_list .js-shop-list-item').hide();
            $('.js_shop_items_list .js-shop-list-item[data-letter='+letter+']').show();

        },

        vendorsLetterClick: function(e){

            var btn = $(this),
                letter = btn.attr('data-letter'),
                listWrapper = $('#js-shop-list-by-letters_vendors');

            // loader.show();

            // отключаем другие активные буквы, если они есть
            $('.js-shop-vendors-letters-item.active').removeClass('active');

            btn.addClass('active');

            listWrapper.addClass('shop-list-by-letters_one-letter');

            listWrapper
                .find('.js-shop-list-by-letters-item[data-letter='+letter+']').show()
                .siblings().hide();

        },

        navbarToggleClick: function(e) {
		    var btn = $(this),
                navbar = btn.closest('.navbar');

            navbar.toggleClass('navbar-expanded', btn.not('.collapsed'));
        },

        shopStoresTextButtonClick: function(e) {
		    e.preventDefault();

		    var btn = $(this),
                mode = btn.attr('data-show');

            btn.hide()
                .siblings().show();

            $('.js-shop-stores_mode_'+mode).addClass('active')
                .siblings().removeClass('active');

        },

        shopOrderPickupLinkClick: function(e) {
		    e.preventDefault();

		    var btn = $(this),
                mode = btn.attr('data-show');

            btn.addClass('active')
                .siblings().removeClass('active');

            $('.js-shop-stores_mode_'+mode).addClass('active')
                .siblings().removeClass('active');

        },

        shopOrderDeliveryDateSelect: function() {
		    var dropdownToggle = $('#js-dropdown-toggle_delivery-date'),
                dayOfWeek = $(this).attr('data-day-of-week'),
                onlyLateTime = ($(this).attr('data-only-late-time')==='true'),
                date = $(this).attr('data-date')
            ;

            dropdownToggle.text( dayOfWeek + ' (' + date + ')' );

            if (onlyLateTime) {
                $('#delivery_time1')
                    .prop('checked', false)
                    .prop('disabled', true);
            } else {
                $('#delivery_time1').prop('disabled', false);
            }

            app.toggleSubmitButtonActiveState();

        },

        shopOrderDeliveryTimeSelect: function() {

            app.toggleSubmitButtonActiveState();

        },

        shopStoresTabButtonClick: function(e) {
		    e.preventDefault();

		    var btn = $(this),
                mode = btn.attr('data-show');

            btn.addClass('active')
                .siblings().removeClass('active');

            $('.js-shop-stores_mode_'+mode).addClass('active')
                .siblings().removeClass('active');

            // правая часть с текстами скрывается при просмотре списка
            $('#js-shop-stores__tabs').toggleClass('shop-stores__row_hidden-right', mode === 'list');

        },

		filterItems: function(e){
			e.preventDefault();
			var form = $('#js_shop_filter'),
				// ser_data = form.serialize(),
				ser_data = $('input, textarea, select', form).not('[value=""]').serialize(),
				form_action = form.attr('action'),
				current_url = '//' + window.location.hostname + (window.location.port ? ':'+window.location.port : '') + form_action + "?" + ser_data,
				submit_button = $(this).find('button[type=submit]'),
				loader = $('#js_overlay_loader');

			loader.show();
			//$('#js_floatsubmit').hide();
			//submit_button.attr('disabled', 'disabled').text('Фильтруем'); //Изменение кнопки на "Добавляем"

			//console.log(current_url);

            $.ajax({
                type: 'get',
                url: current_url,
                success: function (data) {
                    $('#js_content_ajax').replaceWith( $(data).find('#js_content_ajax') );
                },
                complete: function(){

                    $('#js_catdescription').html(' ');
                    loader.hide();
                    history.pushState('', '', current_url);
                    app_refresh.initialize();
                }
            });

		},

		sortItems: function(){

			var form = $('#js_shop_filter'),
				loader = $('#js_overlay_loader');

			loader.show();

			var href = $(this).attr('href');
			href = href.replace("?","");

			if(form.length) {
				var form_action = form.attr('action'),
                    ser_data = $('input, textarea, select', form).not('[value=""]').serialize(),
                    // ser_data = form.serialize(),
					current_url = '//' + window.location.hostname + (window.location.port ? ':'+window.location.port : '') + form_action + "?" + ser_data + "&" + href;
			} else {
				var current_url = '//' + window.location.hostname + (window.location.port ? ':'+window.location.port : '') + window.location.pathname + "?" + href;
			}

            $.ajax({
                type: 'get',
                url: current_url,
                success: function (data) {
                    $('#js_content_ajax').replaceWith( $(data).find('#js_content_ajax') );
                },
                complete: function(){
                    loader.hide();
                    app_refresh.initialize();

                    history.pushState('', '', current_url);
                }
            });

			return false;

		},

		standartPagination: function(e){
			e.preventDefault();

			var href = 'page=' + $(this).attr('data-page'),
				FILTER = $('#js_shop_filter'),
				SEARCHPAGE = $('#js_searchpage'),
				loader = $('#js_overlay_loader');

			loader.show();

			if(FILTER.length){ //страница с фильтром

				var ser_data = FILTER.serialize(),
					form_action = FILTER.attr('action'),
					current_url = '//' + window.location.hostname + form_action + "?" + ser_data + "&" + href;
			} else {

				if(SEARCHPAGE.length){ //страница поиска
					var squery = $('#js_searchpage .js_searchpage_input').val(),
						current_url = '//' + window.location.hostname + window.location.pathname + "?squery=" + squery + "&" + href;
				} else {
					var current_url = '//' + window.location.hostname + window.location.pathname + "?" + href;
				}
			}

			$('#js_content_ajax').load(current_url+" #js_content_ajax", function(){
				loader.hide();

				$('html, body').animate({
					scrollTop: $("#js_content_ajax").offset().top - 60
				}, 500);

				app_refresh.initialize();
				history.pushState('', '', current_url);
			});

			return false;
		},

		morenavPagination: function(){

			var page = $(this).val(),
				nextpage = parseInt(page) + 1,
				href = 'page=' + nextpage,
				FILTER = $('#js_shop_filter'),
				SEARCHPAGE = $('#js_searchpage'),
				loader = $('#js_overlay_loader');

			if(FILTER.length){ //страница с фильтром
				var ser_data = FILTER.serialize(),
					form_action = FILTER.attr('action'),
					current_url;
					//ser_data_arr = [],
					//ser_data_arr_clear = [];

				//ser_data_arr = ser_data.split('&');
				//for (var i = 0; i < ser_data_arr.length; i++) {
				//	if(ser_data_arr[i].slice(-1) != '='){
				//		ser_data_arr_clear[i] = ser_data_arr[i];
				//	}
				//}
				//ser_data = ser_data_arr_clear.join('&');

				if(ser_data){
					href = "&" + href;
				}

				current_url = '//' + window.location.hostname + (window.location.port ? ':'+window.location.port : '') + form_action + "?" + ser_data + href;
			} else {

				if(SEARCHPAGE.length){ //страница поиска
					var squery = $('#js_searchpage .js_searchpage_input').val(),
						current_url = '//' + window.location.hostname + (window.location.port ? ':'+window.location.port : '') + window.location.pathname + "?squery=" + squery + "&" + href;
				} else {
					var current_url = '//' + window.location.hostname + (window.location.port ? ':'+window.location.port : '') + window.location.pathname + "?" + href;
				}

			}

			loader.show();
			$.ajax({
				type: 'get',
				url: current_url,
				success: function (data) {
					var content = $(data).find('#js_shop_items_list_ajax'+nextpage);
					$('#js_morenav_wrapper'+page).html(content);
				},
				complete: function(){
					app_refresh.initialize();
					loader.hide();

					history.pushState('', '', current_url);
				}
			});


			return false;
		},

		contentMorePagination: function(){

			var btn = $(this),
                page = btn.val(),
				nextpage = parseInt(page, 10) + 1,
				href = 'page=' + nextpage,
			    searchForm = $('#js-blog-search-form'),
                searchStr = $('input[type=text]', searchForm).val(),
                next_url;
				// loader = $('#js_overlay_loader');

            if (searchForm.length) {

                if (searchStr) {
                    next_url = searchForm.serialize() + '&'+href;
                } else {
                    next_url = href;
                }

                next_url = searchForm.attr('action') + '?' + next_url;
            } else {
                next_url = '//' + window.location.hostname + (window.location.port ? ':'+window.location.port : '') + window.location.pathname + "?" + href;
            }

			// loader.show();

            btn.addClass('btn-loader');

			$.ajax({
				type: 'get',
				url: next_url,
				success: function (data) {
					var items = $(data).find('.js-articles-list-item');
					var more = $(data).find('#js-articles-list__more'+nextpage);

					$('#js-articles-list__row').append(items);

					$('#js-articles-list__more'+page).replaceWith(more);
				},
				complete: function(){
					app_refresh.initialize();
					// loader.hide();
                    btn.removeClass('btn-loader');

					history.pushState('', '', next_url);
				}
			});


			return false;
		},

        feedbackMorePagination: function(){

			var btn = $(this),
                page = btn.val(),
				nextpage = parseInt(page, 10) + 1,
				href = 'page=' + nextpage;

                var next_url = '//' + window.location.hostname + (window.location.port ? ':'+window.location.port : '') + window.location.pathname + "?" + href;

            btn.addClass('btn-loader');

			$.ajax({
				type: 'get',
				url: next_url,
				success: function (data) {
					var items = $(data).find('.js-shop-feedback__item');
					var more = $(data).find('#js-feedbacks-list__more'+nextpage);

					$('#js-shop-feedback__list').append(items);

					$('#js-feedbacks-list__more'+page).replaceWith(more);
				},
				complete: function(){
					// app_refresh.initialize();
					// loader.hide();
                    btn.removeClass('btn-loader');

					history.pushState('', '', next_url);
				}
			});


			return false;
		},

        feedbackShopItemMorePagination: function(){

			var btn = $(this),
                page = parseInt(btn.val(), 10),
				nextpage = page + 1,
                item_id = parseInt(btn.attr('data-item-id'), 10);

            btn.addClass('btn-loader');

			$.ajax({
				type: 'get',
				url: '/core/ajax/get_feedbacks_for_shop_item.php?page='+nextpage + '&item_id='+item_id,
				success: function (data, textStatus) {

                    if ( textStatus==='success' && data.success ){

                        var html = $(data.html);

                        var items = html.find('.js-shop-feedback__item_page-item');
                        var more = html.find('#js-feedbacks-list__more_page-item'+nextpage);

                        $('#js-shop-feedback__list_page-item').append(items);

                        $('#js-feedbacks-list__more_page-item'+page).replaceWith(more);
                    }
				},
				complete: function(){
                    btn.removeClass('btn-loader');
				}
			});


			return false;
		},

		floatSubmitButton: function(e){

			var label = $(this).parent(),
				otstup = label.position(),
				floatsubmit = $("#js_floatsubmit");

			otstup.top = otstup.top - 5;
			floatsubmit.css("top", otstup.top + "px").show();

		},

		addtocartItemsList: function(e){
			e.preventDefault();

			var form = $(this),
				item_data = form.serialize(),
				loader = $('#js_overlay_loader'),
                btn = form.find('[type=submit]');

			loader.show();

			$.ajax({
				type: 'post',
				url: '/katalog/addtocart',
				data: item_data,
				success: function (data) {
					$('.js_cart_wrapper').replaceWith(data);

                    btn.text( btn.attr('data-text-added') );
                    btn.closest('.shop-list-item-to-cart').addClass('shop-list-item-to-cart_added');

                    setTimeout(function () {
                        btn.text( btn.attr('data-text-default') );
                        btn.closest('.shop-list-item-to-cart').removeClass('shop-list-item-to-cart_added');
                    }, 3000);

					// if(!form.find('.js_itemincart').length){
					// 	form.append('<div class="alert alert-info js_itemincart" role="alert"><div>Товар добавлен в корзину<br/><a href="/katalog/cart.html">Перейти к оформлению</a></div></div>');
					// }

                    // событие eCommerce добавление в корзину
                    var product = form.data(),
                        quantity = parseInt(form.find('.js_item_addqty').val(), 10);
                    // новый объект, иначе при выборе вариантов косячит название
                    var productAdd = {
                        title: product.title,
                        id: product.id,
                        price: product.price,
                        brand: product.brand,
                        category: product.category,
                        quantity: quantity ? quantity : 1,
                    };
                    // если есть варианты, то меняем цену и дополняем название.
                    if ( form.find('.js-shop-list-item-var-art-no-input').length ) {
                        var varArtNo = form.find('.js-shop-list-item-var-art-no-input').val(),
                            variant = form.find('.js-shop-list-item-var[data-var-art-no="'+varArtNo+'"]');

                        variant = variant.data();

                        productAdd.title = product.title + '. ' + variant.varTitle;
                        productAdd.price = variant.varPrice;

                        // console.log('productAdd', productAdd);
                    }
                    app.dataLayerPushAddProduct(productAdd);
                    // конец - событие eCommerce добавление в корзину

				},
				complete: function (data) {
					app_refresh.initialize();
					loader.hide();
				}
			});
		},

        itemsListChangeVarSelect: function() {
		    var button = $(this),
                itemVarCurrent = button.closest('.js-shop-list-item-var'),
                itemVarTarget,
                form = button.closest('form.js_addtocart_list');

		    var direction = button.attr('data-direction');

		    if(direction === 'prev') {
                itemVarTarget = itemVarCurrent.prev();
            } else {
                itemVarTarget = itemVarCurrent.next();
            }

            itemVarTarget.show().siblings('.js-shop-list-item-var').hide();

		    var itemVarArtNoValue = itemVarTarget.attr('data-var-art-no'),
                inputVarArtNo = $('.js-shop-list-item-var-art-no-input', form);

            inputVarArtNo.val(itemVarArtNoValue);
        },

		addtocartItemPage: function(e){
			e.preventDefault();
			var form = $(this),
				item_data = form.serialize(),
				loader = $('#js_overlay_loader');

			loader.show();
			// $('#js_itemincart, #js_addtocarterror').hide();

			$.ajax({
				type: 'post',
				url: '/katalog/addtocart',
				data: item_data,
				success: function (data) {
					$('.js_cart_wrapper').replaceWith(data);
					// $('#js_itemincart').fadeIn();

                    $('#js_addtocartwrapper').hide();
                    $('#js_after_add2cart_wrapper').show();

                    // событие eCommerce добавление в корзину
                    var product = form.data(),
                        quantity = parseInt(form.find('.js_qty_input').val(), 10);
                    // новый объект, иначе при выборе вариантов косячит название
                    var productAdd = {
                        title: product.title,
                        id: product.id,
                        price: product.price,
                        brand: product.brand,
                        category: product.category,
                        quantity: quantity ? quantity : 1,
                    };
                    // если есть варианты, то меняем цену и дополняем название.
                    var variant = form.find('.shop-item-page__var-radio:checked');
                    if (variant.length) {

                        variant = variant.data();

                        productAdd.title = product.title + '. ' + variant.varTitle;
                        productAdd.price = variant.varPrice;
                    }
                    app.dataLayerPushAddProduct(productAdd);

                    // console.log('productAdd', productAdd);
                    // конец - событие eCommerce добавление в корзину

				},
				complete: function (data) {
					loader.hide();
					app_refresh.initialize();
				}
			});
		},

        cancelCartItemPage: function() {
            $('#js_addtocartwrapper').show();
            $('#js_after_add2cart_wrapper').hide();
        },

        feedbackStarMouseEnter: function() {
            var star = $(this),
                rate = star.attr('data-rate'),
                rating = star.closest('.js-feedback-rating');

            rating.attr('data-rating-hover', rate);
        },

        feedbackStarMouseLeave: function() {
            var rating = $(this).closest('.js-feedback-rating');

            rating.removeAttr('data-rating-hover');
        },

        feedbackStarClick: function() {
            var star = $(this),
                rate = star.attr('data-rate'),
                rating = star.closest('.js-feedback-rating');

            rating.attr('data-rating', rate)
                .removeAttr('data-rating-hover');

            $('#js-feedback-rating-input').val(rate);
        },

        speedBuyBtnClick: function(e) {
            e.preventDefault();
            var form = $('#js_addtocart_itempage'),
                item_data = form.serialize(),
                loader = $('#js_overlay_loader'),
                btn = $(this);

            loader.show();
            // $('#js_itemincart, #js_addtocarterror').hide();

            $.ajax({
                type: 'post',
                url: '/katalog/addtocart',
                data: item_data,
                success: function (data) {
                    $('.js_cart_wrapper').replaceWith(data);
                    window.location.href = btn.attr('href');
                },
                error: function () {
                    loader.hide();
                }
            });
        },

        // переключение основной фотографии при клике на миниатюру на странице товара
        // это вместо двух объединённых slick-слайдеров
        itemImagesImgWrapClick: function() {

		    var image = $(this),
                file = image.attr('data-file');

		    if(!file) return false;

		    image.addClass('active')
                .parent()
                .siblings()
                .children('.js-shop-item-page-images__img-wrap')
                .removeClass('active');

		    $('.js-shop-item-page-image').find( '[data-file="'+file+'"]' )
                .addClass('image_visible')
                .siblings().removeClass('image_visible');

        },

		speedBuy: function(e){
			e.preventDefault();
			var form = $(this);

			if(app.validateForm(form) === false) return false;

			var submit_button = form.find('button[type=submit]'),
				formdata = form.serialize();

			submit_button.attr('disabled', 'disabled').text('Отправляем'); //Изменение кнопки на "Добавляем"

			$.post("/core/ajax/cart_ajax.php", formdata, function(){
				form.hide().next().show();
			});
		},

		speedBuyBeforeModal: function (e) {
			$("#js_simplechars .js_simplechar").each(function(indx, element){
				var charId = $(element).find('select').attr('id'),
					charValue = $(element).find('option:selected').val(),
					charValueTitle = $(element).find('option:selected').attr('data-val-title');

				$("#js_simplechars_speedbuy input."+charId).val(charValue).prev().html(charValueTitle);
			});

			var QTY = $('#js_priceblock .js_qty_input').val();
			$('#js_qty_speedbuy .js_qty_input').val(QTY).next('.value').html(QTY);

			var MODAL_TITLE = $('#js_addtocartwrapper .js_speedbtn span').html();
			$('#js_speedbuyinfo .modal-header .modal-title').html(MODAL_TITLE);
		},

        preOrderBeforeModal: function (e) {
            var button = $(e.relatedTarget),
                itemId = button.attr('data-item-id'),
                modal = $(this),
                input = $('input[data-content-type="product"]', modal);

            if (itemId) {
                input.val(itemId);
            }
		},

		cartQTYchange: function(){

			var THIS = $(this),
				TD = THIS.closest('td'),
				INPUT = TD.find('.js_qty_input'),
				QTY = parseInt(INPUT.val(), 10),
				PACKAGE = parseInt(TD.find('.js_item_package').val(), 10),
				MAXQTY = parseInt(TD.find('.js_maxqty').val(), 10) || 0,
				loader = $('#js_overlay_loader'),
				IS_INPUT, ITOG_QTY;

			loader.show();

			if(!PACKAGE || PACKAGE<1){ PACKAGE = 1; }

			if(MAXQTY%PACKAGE !==0){
				var MAX_COUNT_PACKAGES = MAXQTY / PACKAGE;
				MAX_COUNT_PACKAGES = parseInt(MAX_COUNT_PACKAGES, 10);
				MAXQTY = PACKAGE * MAX_COUNT_PACKAGES;
			}

			// console.log('PACKAGE='+PACKAGE);
			// console.log('MAXQTY='+MAXQTY);

            if(THIS.is('.js_qty_input')){
                ITOG_QTY = QTY;
                IS_INPUT = 1; //флаг проверки изменения через инпут, т.к. qty не меняется в процессе работы скрипта
            }
			if(THIS.is('.js_qty_minus')){
                ITOG_QTY = QTY - PACKAGE;
			}
			if(THIS.is('.js_qty_plus')){
                ITOG_QTY = QTY + PACKAGE;
			}


			if(MAXQTY>0 && ITOG_QTY>MAXQTY){ ITOG_QTY = MAXQTY; }

			if(ITOG_QTY<1 || !ITOG_QTY || ITOG_QTY%PACKAGE!==0){ ITOG_QTY = PACKAGE; }

            // console.log('QTY='+QTY);
            // console.log('ITOG_QTY='+ITOG_QTY);
            // console.log('IS_INPUT='+IS_INPUT);

			if (QTY !== ITOG_QTY || IS_INPUT){ //защита от лишних загрузок при уменьшении ниже 1

                // console.log('QTY !== ITOG_QTY || IS_INPUT');

				var item_in_cart_id = INPUT.attr("rel");
                $.ajax({
                    type: 'post',
                    url: "/core/ajax/cart_ajax.php",
                    data: {item_in_cart_id: item_in_cart_id, qty: ITOG_QTY, mode: "changeqty"},
                    success: function (data) {
                        $('.js_cart_wrapper').replaceWith(data);
                    },
                    complete: function () {
                        $('#js_content_ajax').load("/katalog/cart.html #js_content_ajax", function(){
                            loader.hide();
                            app_refresh.initialize();
                        });
                    }
                });

			} else {
				loader.hide();
			}
		},

		cartDeleteItem: function(e){
			e.preventDefault();

			var delete_url = $(this).attr("href"),
				current_url = window.location.href,
				loader = $('#js_overlay_loader');

			loader.show();

			$.ajax({
				type: 'post',
				url: delete_url,
				success: function (data) {
					$('.js_cart_wrapper').replaceWith(data);
				},
				complete: function () {
                    $('#js_content_ajax').load(current_url + " #js_content_ajax", function(){

                        loader.hide();
                        app_refresh.initialize();
                    });
				}
			});

		},

		itemPageQTYchange: function(){

			var THIS = $(this),
				FORM = THIS.closest('form'),
				INPUT = FORM.find('.js_qty_input'),
				btnMinus = FORM.find('.js_qty_minus'),
				btnPlus = FORM.find('.js_qty_plus'),
				QTY = INPUT.val(),
				PACKAGE = parseInt($('#js_item_package').val()),
				MAXQTY = parseInt($('#js_item_maxqty').val());

			if(!PACKAGE || PACKAGE<1){ PACKAGE = 1; }

			if(MAXQTY%PACKAGE !=0){
				var MAX_COUNT_PACKAGES = MAXQTY / PACKAGE;
				MAX_COUNT_PACKAGES = parseInt(MAX_COUNT_PACKAGES);
				MAXQTY = PACKAGE * MAX_COUNT_PACKAGES;
			}

			if(THIS.is('.js_qty_input')){
				QTY = parseInt(QTY);
			}
			if(THIS.is('.js_qty_minus')){
				QTY = parseInt(QTY)-PACKAGE;
			}
			if(THIS.is('.js_qty_plus')){
				QTY = parseInt(QTY)+PACKAGE;
			}

			if(MAXQTY>0 && QTY>MAXQTY){ QTY = MAXQTY; }

			if(QTY<1 || !QTY || QTY%PACKAGE!=0){ QTY = PACKAGE; }

            btnMinus.toggleClass('disabled', QTY === PACKAGE);
            btnPlus.toggleClass('disabled', QTY === MAXQTY);

			INPUT.val(QTY);
		},

		itemsListQTYchange: function(){

			var THIS = $(this),
				FORM = THIS.closest('form'),
				INPUT = FORM.find('.js_item_addqty'),
				QTY = INPUT.val(),
				PACKAGE = FORM.find('.js_item_package').val(),
				MAXQTY = FORM.find('.js_item_maxqty').val();

            PACKAGE = parseInt(PACKAGE, 10);
            MAXQTY = parseInt(MAXQTY), 10;

			if(!PACKAGE || PACKAGE<1){ PACKAGE = 1; }

			if(MAXQTY % PACKAGE !==0){
				var MAX_COUNT_PACKAGES = MAXQTY / PACKAGE;
				MAX_COUNT_PACKAGES = parseInt(MAX_COUNT_PACKAGES, 10);
				MAXQTY = PACKAGE * MAX_COUNT_PACKAGES;
			}

			if(THIS.is('.js_item_addqty')){
				QTY = parseInt(QTY, 10);
			}
			if(THIS.is('.js_qty_minus')){
				QTY = parseInt(QTY, 10)-PACKAGE;
			}
			if(THIS.is('.js_qty_plus')){
				QTY = parseInt(QTY, 10)+PACKAGE;
			}

			if(MAXQTY>0 && QTY>MAXQTY){ QTY = MAXQTY; }

			if(QTY<1 || !QTY || QTY % PACKAGE!==0){ QTY = PACKAGE; }

			INPUT.val(QTY);
		},

		itemChangeVars: function(e){

			var THIS = $(this),
				vars_code = $("#js_vars_code").val(),
				current_url = '//' + window.location.hostname + window.location.pathname,
				chars = {},
				loader = $('#js_overlay_loader');


			if(!THIS.is('.js_selected')){
				THIS.parent().parent().find('.js_selected').removeClass('js_selected');
				THIS.addClass('js_selected');

				$("#js_shop_item_page .js_changed_char .js_selected").each(function(indx, element){
					var THIS_INPUT = $(element).prev('input'),
						charID = THIS_INPUT.attr('data-charid'),
						charValue = THIS_INPUT.val();

					chars[charID] = charValue;
				});

				loader.show();
				$('#js_content_ajax').load(current_url + " #js_content_ajax", {chars: chars, vars_code: vars_code}, function(responseText, textStatus, XMLHttpRequest){

					app_refresh.initialize();

					if (textStatus == "error") {
						$('#js_priceblock #js_addtocartwrapper .js_btn').addClass('disabled');
						$('#js_priceblock .price').html('Нет в наличии');
						$('#js_zakazbutton').attr('disabled', 'disabled');
						history.pushState('', '', current_url);
					}

					if (textStatus == "success") {
						var itemvarid = $('#js_add_to_cart_item_id').val();

						//	var filename = 'shop'+itemvarid+'.jpg',
						//	var_img = $("#js_shop_item_pageitem_image .images a[rev='"+filename+"']");
                        //
						//if (var_img.length){
						//	var href = var_img.attr('href');
						//	$('#main_image_item').attr('href', href).attr('rev', filename).children().attr('src', href);
						//}


						history.pushState('', '', current_url+'?itemvarid='+itemvarid);
					}

					loader.hide();

				});
			}

		},

        deliveryCityRadioClick: function(e){

            var INPUT = $(this),
                deliveryCity = INPUT.val(),
                order_id = parseInt( $('#js-order-id').val(), 10 ),
                pay_input_val = $('.js_pay_type:checked').val(),
                loader = $('#js_overlay_loader');

            loader.show();

            // $('#js_alert_delivery_types').hide();
            // d_more_form.stop(true,true).slideDown('fast');
            // d_more_form_siblings.stop(true,true).slideUp('fast');

            // if (d_type != 3) { // если не PickPoint, сбрасываем выбранную точку
            //     pickpoint_clear();
            // }

            // $('#js_delivery_types').get(0).innerHTML = '';
            // получает доступные способы доставки
            $.ajax({
                url : "/core/ajax/order_city_select.php",
                dataType : "json",
                data : {
                    city : deliveryCity,
                    pay_type : pay_input_val,
                    order_id : order_id || undefined,
                },
                success : function(data, textStatus) {
                    if ( textStatus==='success' && data.success ){

                        var commentCol = $('#js-shop-order__comment-col'),
                            contactsHeading = $('#js-shop-order__contacts-heading'),
                            deliveryTypes = $('#js_delivery_types');

                        deliveryTypes.get(0).innerHTML = data.html;

                        app.resetAllDependingOnDeliveryType();

                        // убрал. теперь просто сбрасываю все параметры, скрываю блоки и ждём клика по доступному способу доставки.
                        // if (deliveryCity === 'other') {
                        //
                        //     // // скрываем блок с выбором способов доставки
                        //     // $('#js-shop-order__delivery').stop(true,true).slideUp('fast');
                        //
                        //     // скрываем комментарий, т.к. для почты России его нет
                        //     commentCol.hide();
                        //     // меняем заголовок блока с контактами
                        //     contactsHeading.text(contactsHeading.attr('data-text-post'));
                        //
                        //     // расчет итоговой стоимости без доставки, т.к. она пока не рассчитана
                        //     var decimals = parseInt($('#show_decimals').val());
                        //
                        //     var result_summ = Number($('#js_cart_total_summ').html());
                        //     if (decimals) {
                        //         result_summ = (Math.round(result_summ * 100) / 100).toFixed(decimals);
                        //     } else {
                        //         result_summ = Math.round(result_summ);
                        //     }
                        //
                        //     result_summ = String(result_summ).replace('.00', '');
                        //
                        //     $('#js_resultsumm').html(result_summ);
                        //
                        //     // прописываем строку со стоимостью доставки
                        //     $('#js-shop-order__delivery-value').text( 'нужен расчет' );
                        //
                        //     // показать блок с контактами и сделать его поля обязательными
                        //     $('#js-shop-order__contacts')
                        //         .stop(true,true).slideDown('fast')
                        //         .find('.js-customer-address-required').prop('required', true);
                        //
                        //     $("#js-post-order-min-sum").text( $('#d_type4').attr('data-order-min-sum') ); // прописать мин. сумму заказа для доставки почтой
                        //
                        //     // показать блок с рассчетом доставки Почтой России
                        //     $('#js-shop-order__post-delivery-calc')
                        //         .stop(true,true).slideDown('fast');
                        //
                        //     // скрываем блок с выбором точки самовывоза
                        //     $('#js_shop-order__delivery-pickup').stop(true,true).slideUp('fast');
                        //
                        //     // выключаем блок с датой доставки
                        //     app.hideDeliveryDatesBlock();
                        //
                        // } else {
                        //     // // показываем блок с выбором способа доставки
                        //     // $('#js-shop-order__delivery').stop(true,true).slideDown('fast');
                        //
                        //     // показываем блок с радио кнопкой курьерской доставки. нужно, когда возвращаемся с другого города в Москву. обычно включается при инициализации яндекс.карт.
                        //     // $('.js-shop-order__delivery-type[data-dtype-id="2"]').show();
                        //
                        //     // скрыть блок с рассчетом доставки Почтой России
                        //     $('#js-shop-order__post-delivery-calc')
                        //         .stop(true,true).slideUp('fast');
                        //
                        //     // скрываем блок с контактами, т.к. по умолчанию будет самовывоз
                        //     $('#js-shop-order__contacts')
                        //         .stop(true,true).slideUp('fast')
                        //         .find('.js-customer-address-required').prop('required', false);
                        //
                        //     // показывем комментарий
                        //     commentCol.show();
                        //     // меняем заголовок блока с контактами
                        //     contactsHeading.text(contactsHeading.attr('data-text-common'));
                        //
                        //     // включаем блок с датой доставки
                        //     app.showDeliveryDatesBlock();
                        // }


                        // вызываем клик на первом доступном способе доставки, если такой есть
                        deliveryTypes
                            .find(".js_d_type:not(disabled)")
                            .eq(0).trigger('click');

                        app.toggleSubmitButtonActiveState(); // включаем/выключаем кнопку Продолжить

                        app.dataLayerPushCheckoutCart(4); // шаг 4 - Город получения заказа

                    } else {
                        console.log(data.message);
                    }
                },
                complete : function(){
                    loader.hide();
                }
            });

            // расчет итоговой стоимости без доставки, т.к. она пока не рассчитана
            var decimals = parseInt($('#show_decimals').val());

            var result_summ = Number($('#js_cart_total_summ').html());
            if (decimals) {
                result_summ = (Math.round(result_summ * 100) / 100).toFixed(decimals);
            } else {
                result_summ = Math.round(result_summ);
            }

            result_summ = String(result_summ).replace('.00', '');

            $('#js_resultsumm').html(result_summ);

		},

		formsSubmit: function(e){

			var form = $(this),
				submitBtn = form.find('input[type="submit"]');

			if(app.validateForm(form) === false) return false;

		},

		formsContactSubmit: function(e){

			e.preventDefault();
			var form = $(this),
				loader = $('#js_overlay_loader'),
				submitBtn = form.find('[type="submit"]');


			if(app.validateForm(form) === true) {

				$('.js_error_response', form).remove();

				loader.show();
				var action = form.find('input[name=mainfield]').val();

				var form_data = new FormData(form[0]),
					files = form.find('input[type=file]');

				$.each(files, function(i, file) {
					form_data.append($(file).attr('name'), file);
				});

				$.ajax({
					type: "POST",
					url : action,
					contentType: false, // It’s imperative that you set the contentType option to false, forcing jQuery not to add a Content-Type header for you, otherwise, the boundary string will be missing from it.
					cache: false,
					processData: false, // Also, you must leave the processData flag set to false, otherwise, jQuery will try to convert your FormData into a string, which will fail.
					//data : form.serialize(),
					data : form_data,
					success : function(responseText, textStatus) {

						if (textStatus == "error") {
							form.addClass('form_error_sended');
						}

						if (textStatus == "success") {
							form.addClass('form_success_sended');

							var download_file = $('#js-form-file-download').val();

							if (download_file) {
							    setTimeout(function () {
                                    window.location.href = download_file;
                                }, 1000);
                            }
						}

						form.html(responseText);
					},
					error : function(data) {

						form.addClass('form_error_sended');

						form.append(data.responseText);
					},
					complete : function(){
						loader.hide();

						app_refresh.initialize();
					}
				});
			}

		},

        registrationFormSubmitBtnClick: function(e){
            e.preventDefault();

            var form = $(this).closest('form');

            grecaptcha.ready(function() {
                grecaptcha.execute('6Ld1HbgZAAAAAO7M6toY2GBuuYMfrAcjEUbuY50p', {action: 'submit'}).then(function(token) {
                    // Add your logic to submit to your backend server here.

                    $('#jsRegisterToken').val(token);

                    form.submit();

                });
            });


        },

		// validateForm: function(form){
		// 	var inputs = form.find('input:required, textarea:required'),
		// 		valid = true;
        //
		// 	//inputs.tooltip('destroy'); // без него тултипы не глючат
        //
		// 	$.each(inputs, function(index, val){
		// 		var input = $(val),
		// 			val = input.val(),
		// 			formGroup = input.parents('.form-group'),
		// 			tooltiptitle = 'Обязательно',
		// 			error = false;
        //
		// 		if(val.length === 0){
		// 			error = true;
		// 		}
		// 		else if(input.is('#pass2input')){
		// 			var pass1 = $("#pass1input").val();
		// 			if (pass1 != val) {
		// 				tooltiptitle = 'Пароли не совпадают';
		// 				error = true;
		// 			}
		// 		}
		// 		else if(input.is('input[type="email"]') || input.is('#emailreginput')){
		// 			var reg = new RegExp("^([a-zA-Z0-9_\._-])+@[a-zA-Z0-9_-]+\.([a-z]{2,4}\.)?[a-z]{2,4}$");
		// 			if (reg.test(val)) {
		// 				$("#emailcheck").load("/core/ajax/registration.php", {opt: "checklogin", data:val}, function(){
		// 					//пришлось так сделать, т.к. не получается установить флаг ошибки в callback-функции при проверке занятости email
		// 					var emailbusy = $("#emailcheck").html();
		// 					if(emailbusy){
		// 						formGroup.addClass('has-error').removeClass('has-success');
		// 						input.tooltip({
		// 							trigger: 'manual',
		// 							placement: 'right',
		// 							title: 'Email уже зарегистрирован'
		// 						}).tooltip('show');
		// 					}
		// 				});
        //
        //
		// 			} else {
		// 				tooltiptitle = 'Ошибка ввода E-mail';
		// 				error = true;
		// 			}
		// 		}
        //
		// 		if(error){
		// 			formGroup.addClass('has-error').removeClass('has-success');
		// 			input.tooltip({
		// 				trigger: 'manual',
		// 				placement: 'right',
		// 				title: tooltiptitle
		// 			}).tooltip('show');
		// 			valid = false;
		// 		} else {
		// 			formGroup.addClass('has-success').removeClass('has-error');
		// 		}
		// 	});
        //
		// 	if($('#emailreginput').next().is('.tooltip')) valid = false; //пришлось так сделать, т.к. не получается установить флаг ошибки в callback-функции при проверке занятости email
        //
		// 	return valid;
		// },

		validateForm: function(form, addClassesToCheckedElements){
			var inputs = form.find('input:required:not(.js-novalidate), textarea:required:not(.js-novalidate)'),
				valid = true;

			// пришлось так сделать, т.к. со значением переменной по умолчанию не проходит сборка в gulp
            addClassesToCheckedElements = (typeof(addClassesToCheckedElements) != "undefined" && addClassesToCheckedElements !== null) ? addClassesToCheckedElements : true;

			//inputs.tooltip('destroy'); // без него тултипы не глючат

			$.each(inputs, function(index, elem){
				var input = $(elem),
					val = input.val(),
					type = input.attr('type'),
					formGroup = input.parents('.form-group'),
					tooltiptitle = 'Обязательно',
					error = false;

				if(val.length === 0){
					error = true;
				}
				else if(type === 'checkbox' && !input.is(':checked')){
					error = true;
				}
				else if(input.is('#pass2input')){
					var pass1 = $("#pass1input").val();
					if (pass1 != val) {
						tooltiptitle = 'Пароли не совпадают';
						error = true;
					}
				}
				else if(input.is('input[type="email"]') || input.is('#emailreginput')){
					var reg = new RegExp("^([a-zA-Z0-9_\._-])+@[a-zA-Z0-9_-]+\.([a-z]{2,4}\.)?[a-z]{2,4}$");
					if (reg.test(val)) {
						$("#emailcheck").load("/core/ajax/registration.php", {opt: "checklogin", data:val}, function(){
							//пришлось так сделать, т.к. не получается установить флаг ошибки в callback-функции при проверке занятости email
							var emailbusy = $("#emailcheck").html();
							if(emailbusy){
                                tooltiptitle = 'Email уже зарегистрирован';
                                error = true;
							}
						});


					} else {
						tooltiptitle = 'Ошибка ввода E-mail';
						error = true;
					}
				}
				if(error){

                    if(addClassesToCheckedElements) {
                        formGroup.addClass('has-error').removeClass('has-success');
                        // if( !input.attr('data-original-placeholder') ) {
                        //     input.attr('data-original-placeholder', input.attr('placeholder'))
                        // }
                        input
                        // .attr('placeholder', tooltiptitle)
                            .addClass('is-invalid');
                    }

                    // setTimeout(function () {
                    //     var originalPlaceholder = input.attr('data-original-placeholder');
                    //     if (originalPlaceholder) {
                    //         input.attr('placeholder', originalPlaceholder);
                    //     }
                    // }, 2000);

					// input.tooltip({
					// 	trigger: 'manual',
					// 	placement: 'right',
					// 	title: tooltiptitle
					// }).tooltip('show');
					valid = false;
				} else {

                    if(addClassesToCheckedElements) {
                        formGroup.addClass('has-success').removeClass('has-error');
                    }
				}
			});

			if($('#emailreginput').next().is('.tooltip')) valid = false; //пришлось так сделать, т.к. не получается установить флаг ошибки в callback-функции при проверке занятости email

			return valid;
		},

		formsRemoveError: function(){
			// $(this).tooltip('destroy').parents('.form-group').removeClass('has-error');
			$(this)
                .removeClass('is-invalid')
                .parents().removeClass('has-error');

			// var originalPlaceholder = $(this).attr('data-original-placeholder');
			// if (originalPlaceholder) {
            //     $(this).attr('placeholder', originalPlaceholder);
            // }
		},

		orderSubmitFinish: function(e){

			var form = $(this),
                form_data = form.serialize(),
				action = form.attr('action'),
				btn = $('#js_order_form_submit'),
				btn_origin_text = btn.text(),
				is_error = 0,
				current_url = window.location.href,
				webmoney_form = $('#webmoney_WMR'),
				loader = $('#js_overlay_loader');

            if(app.validateForm(form) === false) {
                e.preventDefault();
                return false;
            }

            // если редактирование доставки заказа, то просто даём закончить сабмит
            if ( form.is('.js-edit-order-delivery-form') ) {
                return true;
            }

			loader.show();
			btn.attr('disabled', 'disabled');
			btn.text('Отправляем ...');

			// if ( !$('#js_customer_agree').is(':checked') ) {
			// 	$('#js_alert_customer_agree').show();
			// 	is_error = 1;
			// }

			if ( !$('#js_payment_methods input').is(':checked') ) {
				$('#js_alert_payment_methods').show();
				is_error = 1;
			}

			if(is_error){

				loader.hide();
				btn.removeAttr('disabled');
				btn.text(btn_origin_text);

				return false;
				e.preventDefault();
			}

			if( $('#pay_type_webmoney').is(':checked') && webmoney_form.length ) { // если выбрана оплата вебмани, и есть форма вебмани
				// отправляем основную форму аяксом
				$.ajax({
					type: "POST",
					dataType : "json",
					url : action,
					data : form.serialize(),
					success : function(data) {
						if ( data.success == 1 ){
							// если заказ создан успешно, прописываем его параметры в форме вебмани
							$('input[name=order_id]',           webmoney_form).val(data.order.id);
							$('input[name=LMI_PAYMENT_AMOUNT]', webmoney_form).val(data.order.summ);
							$('input[name=LMI_PAYMENT_DESC]',   webmoney_form).val("Payment for order " + data.order.id);
							$('input[name=LMI_PAYMENT_NO]',     webmoney_form).val(data.order.id);
							webmoney_form.submit();
						} else {
							// иначе ошибка, возвращаем на страницу оформления заказа
							window.location.href = current_url;
						}
					},
					error : function() {
						// если какая-то ошибка, возвращаем на страницу оформления заказа
						window.location.href = current_url;
					}
				});

				return false;
				e.preventDefault();
			}

			app.dataLayerPushCheckoutCart(6); // шаг 6 - Переход в оплату или завершение заказа

            app.yandexCommerceSend();
            // app.googleCommerceSend();

            e.preventDefault(); // надо отправлять данные в эл. коммерцию об успешном оформлении заказа, поэтому делаем запрос на оформление заказа аяксом.
            $.ajax({
                type: form.attr('method'),
                url: form.attr('action'),
                data: form_data,
                success: function (data, textStatus, jqXHR) {
                    // console.log('data', data);
                    // console.log('textStatus', textStatus);
                    // console.log('jqXHR', jqXHR);
                    if(textStatus==='success' && data.success) {

                        if(data.order) {
                            // console.log('data.order', data.order)
                            app.dataLayerPushPurchase(data.order); // отправка успешного оформления заказа
                        }

                        if (data.redirect_url) {
                            // console.log('data.redirect_url', data.redirect_url)
                            window.location.href = data.redirect_url;
                        } else {
                            loader.hide();
                        }

                    } else {
                        // если какая-то ошибка, возвращаем на страницу оформления заказа
                        window.location.href = current_url;
                    }

                },
                error: function(jqXHR, textStatus, errorThrown) {
                    // console.log('jqXHR', jqXHR);
                    // console.log('textStatus', textStatus);
                    // console.log('errorThrown', errorThrown);

                    // если какая-то ошибка, выводим содержимое ошибки, например страницу 404.
                    $('#js_content_ajax').replaceWith( $(jqXHR.responseText).find('#js_content_ajax') )

                    loader.hide();
                    return;

                    // если какая-то ошибка, возвращаем на страницу оформления заказа
                    // window.location.href = current_url;
                },
                complete: function (jqXHR, status) {
                    // console.log('jqXHR', jqXHR);
                    // console.log('status', status);
                    // return;
                    // не надо, т.к. по итогу либо релоад, либо редирект
                    // loader.hide();
                }
            });

		},

		googleCommerceSend: function(){
			if (typeof ga != 'undefined') {

				ga('require', 'ecommerce');

				var DATA = new Date(),
					Year = DATA.getFullYear(),
					Month = DATA.getMonth() + 1,
					Day = DATA.getDate(),
					ORDER_ID = Day + '.' + Month + '.' + Year + ' ' + DATA.toLocaleTimeString() + ' ' + Math.floor(Math.random() * (1000000 - 1) + 1),
					ORDER_SUM = 0;

				$('.js_ecommerce').each(function () {
					var CART_ITEM = $(this);
					ORDER_SUM = ORDER_SUM + CART_ITEM.data('price') * CART_ITEM.data('quantity');
				});

				ga('ecommerce:addTransaction', {
					'id': ORDER_ID,                     // Transaction ID. Required.
					'affiliation': 'Добрый пасечник',   // Affiliation or store name.
					'revenue': ORDER_SUM,               // Grand Total.
					'shipping': '0',                  // Shipping.
					'tax': '0'                     // Tax.
				});

				$('.js_ecommerce').each(function () {
					var CART_ITEM = $(this);

					if (CART_ITEM.data('price') > 0) {
						ga('ecommerce:addItem', {
							'id': ORDER_ID,                     // Transaction ID. Required.
							'name': CART_ITEM.data('name'),    // Product name. Required.
							'sku': CART_ITEM.data('id'),                 // SKU/code.
							'price': CART_ITEM.data('price'),                 // Unit price.
							'quantity': CART_ITEM.data('quantity')                   // Quantity.
						});
					}
				});

				ga('ecommerce:send');
			}
		},

        yandexCommerceSend: function(){
            if (typeof ym != 'undefined') {

				var CART_ITEMS = [],
					ORDER_SUM = 0;

				$('.js_ecommerce').each(function() {
					var CART_ITEM = $(this);

					if(CART_ITEM.data('price') > 0) {
						CART_ITEMS.push({
							id: CART_ITEM.data('id'),
							name: CART_ITEM.data('name'),
							price: CART_ITEM.data('price'),
							quantity: CART_ITEM.data('quantity')
						});
					}

					ORDER_SUM = ORDER_SUM + CART_ITEM.data('price') * CART_ITEM.data('quantity');
				});

				ym('11490730', 'reachGoal', 'order', {
					order_price: ORDER_SUM,
					currency: "RUB"
				});

				var DATA = new Date(),
					Year = DATA.getFullYear(),
					Month = DATA.getMonth() + 1,
					Day = DATA.getDate(),
					ORDER_ID = Day + '.' + Month + '.' + Year + ' ' + DATA.toLocaleTimeString() + ' ' + Math.floor(Math.random() * (1000000 - 1) + 1);

				dataLayer.push({
					"ecommerce": {
						"purchase": {
							"actionField": {
								"id" : ORDER_ID
							},
							"products": CART_ITEMS
						}
					}
				});
            }
        },

        // клик по ссылке товара в модуле Хиты продаж на главной
        hitsListItemLinkClick: function(e) {

            // e.preventDefault();

            var product = $(this).data();

            // console.log('product', product);

            var e_commerce_list = 'Популярные товары';

            app.dataLayerPushClickProduct(product, e_commerce_list);

            // console.log(dataLayer);

            setCookieMy('e_commerce_list', e_commerce_list, 10); // кука на 10 секунд, чтобы отправить данные по эл. коммерции со страницы товара (Просмотр товара)
        },

        // клик по ссылке товара в любом списке товаров из com_inshop_items_list.tpl
        listItemLinkClick: function(e) {

            // e.preventDefault();

            var product = $(this).data();

            // console.log('product', product);

            var e_commerce_list = $('#js-e_commerce_list').val();

            app.dataLayerPushClickProduct(product, e_commerce_list);

            // console.log(dataLayer);

            setCookieMy('e_commerce_list', e_commerce_list, 10); // кука на 10 секунд, чтобы отправить данные по эл. коммерции со страницы товара (Просмотр товара)

        },

        // клик по ссылке на слайдере на главной
        mainSliderItemLinkClick: function() {

            var title = 'Баннер: ' + $(this).data('slide-title');

            setCookieMy('e_commerce_list', title, 10); // кука на 10 секунд, чтобы отправить данные по эл. коммерции со страницы списка товаров (Просмотр товаров)
        },

        dataLayerPushClickProduct: function(product, e_commerce_list) {
            dataLayer.push({
                'ecommerce': {
                    'currencyCode': 'RUB',
                    'click': {
                        'actionField': {'list': e_commerce_list},
                        'products': [{
                            'name': product.title,
                            'id': product.id,
                            'price': product.price,
                            'brand': product.brand,
                            'category': product.category,
                        }]
                    }
                },
                'event': 'gtm-ee-event',
                'gtm-ee-event-category': 'Enhanced Ecommerce',
                'gtm-ee-event-action': 'Product Clicks',
                'gtm-ee-event-non-interaction': 'False',
            });
        },

        dataLayerPushAddProduct: function(product) {
            dataLayer.push({
                'ecommerce': {
                    'currencyCode': 'RUB',
                    'add': {
                        'products': [{
                            'name': product.title,
                            'id': product.id,
                            'price': product.price,
                            'brand': product.brand,
                            'category': product.category,
                            'quantity': product.quantity,
                        }]
                    }
                },
                'event': 'gtm-ee-event',
                'gtm-ee-event-category': 'Enhanced Ecommerce',
                'gtm-ee-event-action': 'Adding a Product to a Shopping Cart',
                'gtm-ee-event-non-interaction': 'False',
            });
        },

        dataLayerPushCheckoutCart: function(step) {
            var products = [];

            $('.js_ecommerce').each(function() {
                var item = $(this);

                products.push({
                    name: item.attr('data-name'),
                    id: item.attr('data-id'),
                    price: item.attr('data-price'),
                    brand: item.attr('data-brand'),
                    category: item.attr('data-category'),
                    quantity: item.attr('data-quantity')
                });
            });

            dataLayer.push({
                'ecommerce': {
                    'currencyCode': 'RUB',
                    'checkout': {
                        'actionField': {'step': step, 'option': 'cart'},
                        'products': products
                    }
                },
                'event': 'gtm-ee-event',
                'gtm-ee-event-category': 'Enhanced Ecommerce',
                'gtm-ee-event-action': 'Checkout Step '+step+' cart',
                'gtm-ee-event-non-interaction': 'False',
            });

            // console.log('dataLayer', dataLayer);
        },

        dataLayerPushCheckout1Click: function(step) {
            var products = [];

            $('.js_ecommerce').each(function() {
                var item = $(this);

                products.push({
                    name: item.attr('data-name'),
                    id: item.attr('data-id'),
                    price: item.attr('data-price'),
                    brand: item.attr('data-brand'),
                    category: item.attr('data-category'),
                    quantity: item.attr('data-quantity')
                });
            });

            dataLayer.push({
                'ecommerce': {
                    'currencyCode': 'RUB',
                    'checkout': {
                        'actionField': {'step': step, 'option': '1click'},
                        'products': products
                    }
                },
                'event': 'gtm-ee-event',
                'gtm-ee-event-category': 'Enhanced Ecommerce',
                'gtm-ee-event-action': 'Checkout Step '+step+' 1click',
                'gtm-ee-event-non-interaction': 'False',
            });
        },

        dataLayerPushPurchase: function(order) {
            var products = [];

            $('.js_ecommerce').each(function() {
                var item = $(this);

                products.push({
                    name: item.attr('data-name'),
                    id: item.attr('data-id'),
                    price: item.attr('data-price'),
                    brand: item.attr('data-brand'),
                    category: item.attr('data-category'),
                    quantity: item.attr('data-quantity')
                });
            });

            dataLayer.push({
                'ecommerce': {
                    'currencyCode': 'RUB',
                    'purchase': {
                        'actionField': {
                            'id': order.id, //здесь используется id транзакции
                            'revenue': order.summ,
                            'shipping': order.d_price
                        },
                        'products': products
                    }
                },
                'event': 'gtm-ee-event',
                'gtm-ee-event-category': 'Enhanced Ecommerce',
                'gtm-ee-event-action': 'Purchase',
                'gtm-ee-event-non-interaction': 'False',
            });
        },

        toggleSubmitButtonActiveState: function(){

			var form = $('#js-order-form'),
				btn = $('#js_order_form_submit'),
				is_error = false;

			if ( !$('.js_pay_type:not(:disabled):checked').length ) {
                is_error = true;
			}

			if ( !$('.js_d_type:not(:disabled):checked').length ) {
                is_error = true;
			} else {
                var d_type = parseInt( $('.js_d_type:not(:disabled):checked').val(), 10 );

                // если самовывоз или курьер
                if (d_type === 1 || d_type===2) {

                    // // если не выбрана дата доставки
                    // if ( !$('.js-delivery_date_input:not(:disabled):checked').length ) {
                    //     is_error = true;
                    // }
                    // // если не выбрано время доставки
                    // if ( !$('.js-delivery_time_input:not(:disabled):checked').length ) {
                    //     is_error = true;
                    // }
                }

                // если почтой и не рассчитана сумма доставки
                if (d_type === 4) {
                    if ( !$('#js-shop-order__post-delivery-calculated').val() ) {
                        is_error = true;
                    }
                }
            }


            if(app.validateForm(form, false) === false) {
                is_error = true;
            }

			if(is_error){
                btn.prop('disabled', true);
			} else {
                btn.prop('disabled', false);
            }

		},

		orderDeliverySubmit: function(){
			if ( !$('#js_delivery_types input.js_d_type').is(':checked') ) {
				$('#js_alert_delivery_types').text('Вы не выбрали способ доставки').show();
				return false;
			} else {
				if( $('#d_type1').is(':checked') && !$('input.js_input_store').is(':checked') ) { // если самовывоз и нет выбранного магазина
					$('#js_alert_delivery_types').text('Вы не выбрали магазин для самовывоза').show();
					return false;
				}
				if( $('#d_type3').is(':checked') && !$('#js_pickpoint').val() ) { // если PickPoint и нет выбранной точки
					$('#js_alert_delivery_types').text('Вы не выбрали пункт доставки PickPoint').show();
					return false;
				}
				$('#js_alert_delivery_types').hide();

				if ( $('.js_address_required').is(':checked') ) { // если выбран способ доставки, требующий адрес, то показываем и делаем обязательным, иначе скрываем адрес доставки
					$('.customer_address input.form-control').attr('required', 'required');
					$('.customer_address span.required').show();
					$('.customer_address').show();
				} else {
					$('.customer_address input.form-control').removeAttr('required');
                    $('.customer_address span.required').hide();
					$('.customer_address').hide();
				}
			}

		},

		selectDeliveryType: function(){ // при выборе способа доставки
			var INPUT = $(this),
					d_type = parseInt(INPUT.val(), 10),
			//d_price = INPUT.attr('data-price'),
					d_more_form = INPUT.closest('tr').find('.js_more_form'),
					d_more_form_siblings = INPUT.closest('tr').siblings('tr').find('.js_more_form'),
					loader = $('#js_overlay_loader');

			// loader.show();

			$('#js_alert_delivery_types').hide();
			d_more_form.stop(true,true).slideDown('fast');
			d_more_form_siblings.stop(true,true).slideUp('fast');

			if (d_type !== 3) { // если не PickPoint, сбрасываем выбранную точку
				pickpoint_clear();
			}

			var commentCol = $('#js-shop-order__comment-col'),
                contactsHeading = $('#js-shop-order__contacts-heading');
            // если почта России
            if (d_type === 4) {
                commentCol.hide();
                contactsHeading.text(contactsHeading.attr('data-text-post'));

                // показать блок с рассчетом доставки Почтой России
                $('#js-shop-order__post-delivery-calc')
                    .stop(true,true).slideDown('fast');

                $("#js-post-order-min-sum").text( $('#d_type4').attr('data-order-min-sum') ); // прописать мин. сумму заказа для доставки почтой
            } else {
                commentCol.show();
                contactsHeading.text(contactsHeading.attr('data-text-common'));

                // скрыть блок с рассчетом доставки Почтой России
                $('#js-shop-order__post-delivery-calc')
                    .stop(true,true).slideUp('fast');

                // сброс рассчета
                $('#js-shop-order__post-delivery-calculated').val('')
            }

			if ( INPUT.is('.js_address_required') ) {
			    // показать блок с контактами и сделать его поля обязательными

                $('#js-shop-order__contacts')
                    .stop(true,true).slideDown('fast')
                    .find('.js-customer-address-required').prop('required', true);

            } else {
                $('#js-shop-order__contacts')
                    .stop(true,true).slideUp('fast')
                    .find('.js-customer-address-required').prop('required', false);
            }

			// если самовывоз
			if (d_type === 1) {
			    // включаем блок с точками самовывоза и картой
			    app.showDeliveryPickupBlock();
            } else {
			    // выключаем блок
                app.hideDeliveryPickupBlock();
            }

			// если курьерская доставка
			if (d_type === 2) {
			    // включаем блок с картой курьерской доставки
			    app.showDeliveryCourierMap();
            } else {
			    // выключаем блок с картой курьерской доставки
                app.hideDeliveryCourierMap(INPUT); // передаю INPUT, чтобы полю с индексом вернуть обязательность, если нужно.
            }

            // если самовывоз или курьерская доставка
			if (d_type===1 || d_type===2) {

                // включаем блок с датой доставки
                app.showDeliveryDatesBlock();
            } else {

                // выключаем блок с датой доставки
                app.hideDeliveryDatesBlock();
            }

			// если пункты выдачи СДЭК
			if (d_type === 7) {
			    // включаем блок с виджетом СДЭК
			    app.showDeliveryCdekWidget();
            } else {
			    // выключаем блок с виджетом СДЭК
                app.hideDeliveryCdekWidget();
            }

			app.dataLayerPushCheckoutCart(5); // шаг 5 - Способ получения заказа

            // var deliveryCourierModeSelect = $('#js_shop-order__delivery-courier-mode-select'),
            //     deliveryCourierMap = $('#js_shop-order__delivery-courier-map'),
            //     customerAddressPostcode = $('#customer_address_postcode'),
            //     orderContacts = $('#js-shop-order__contacts');
            //
            // // если доставка курьером
            // if (d_type === 2) {
            //     deliveryCourierModeSelect.stop(true,true).slideDown('fast');
            //     deliveryCourierMap.show();
            //
            //     // обязательно надо обновить вьюпорт карты и установить зум, т.к. блок изначально скрыт
            //     setTimeout(function () {
            //         courierMap.container.fitToViewport();
            //     }, 250);
            //
            //     // выключаем поле Индекс
            //     customerAddressPostcode
            //         .removeClass('js-customer-address-required') // удаляем класс обязательности, чтобы не участвовал в его обработке
            //         .val('') // удаляем значение
            //         .prop('required', false) // выключаем обязательность
            //         .closest('.js-shop-order__contacts-col').hide(); // скрываем родительский блок
            //
            //     orderContacts.addClass('shop-order__contacts_courier');
            //     if ( $('.js-shop-order__delivery-courier-btn.active[data-address-mode="map"]').length ) {
            //         orderContacts
            //             .addClass('shop-order__contacts_courier-map')
            //             .removeClass('shop-order__contacts_courier-input');
            //     } else {
            //         orderContacts
            //             .addClass('shop-order__contacts_courier-input')
            //             .removeClass('shop-order__contacts_courier-map');
            //     }
            //
            //     // если выбран способ "Ввести адрес"
            //     if( $('.js-shop-order__delivery-courier-btn.active[data-address-mode="input"]').length ) {
            //         searchAddressFromInputs();
            //     } else {
            //
            //         prepareToShowOnMap();
            //     }
            //
            // } else {
            //     deliveryCourierModeSelect.stop(true,true).slideUp('fast');
            //     deliveryCourierMap.hide();
            //
            //     // возвращаем поле Индекс
            //     customerAddressPostcode
            //         .addClass('js-customer-address-required') // добавляем класс обязательности, чтобы обрабатывался
            //         .closest('.js-shop-order__contacts-col').show(); // отображаем родительский блок
            //     if ( INPUT.is('.js_address_required') ) {
            //         customerAddressPostcode.prop('required', true) // включаем обязательность
            //     }
            //
            //     orderContacts
            //         .removeClass('shop-order__contacts_courier')
            //         .removeClass('shop-order__contacts_courier-map')
            //         .removeClass('shop-order__contacts_courier-input');
            //
            //     // делаем адресные поля редактируемыми
            //     $('.js-customer-address-required').prop('readonly', false);
            // }

			// $('#js_payment_methods').get(0).innerHTML = '';
			// // получает доступные способы оплаты
			// $.ajax({
			// 	url : "/katalog/get_payment_methods",
			// 	dataType : "json",
			// 	data : {
			// 		d_type : d_type,
			// 		//d_price : d_price
			// 	},
			// 	success : function(data) {
			// 		if ( data.success == 1 ){
			// 			$('#js_payment_methods').get(0).innerHTML = data.html;
			// 			$('#js_payment_method_additional').get(0).innerHTML = data.additional;
			// 		} else {
			// 			console.log(data.message);
			// 		}
			// 	},
			// 	complete : function(){
			// 		loader.hide();
			// 	}
			// });

		},

        showDeliveryCdekWidget: function() {

            // var deliveryCdekBlock = $('#js_shop-order__delivery-cdek'),
            //     deliveryCdekInfo = $('#js_shop-order__delivery-cdek-info');
            //
            // // если блок курьерской доставки уже был инициализирован (загружен)
            // if (app.deliveryCdekInitialised) {
            //
            //     // снимаем выделение со способа доставки СДЭК, т.к. пункт самовывоза пока не выбран
            //     $('#d_type7').prop('checked', false);
            //     // вкл/выкл кнопку оформления заказа
            //     app.toggleSubmitButtonActiveState();
            //
            //     // разворачиваем блок
            //     deliveryCdekBlock.show();
            //
            //     // добавляем сообщение о необходимости выбрать пункт
            //     deliveryCdekInfo.html('<div class="alert alert-warning">Выберите пункт выдачи СДЭК.</div>');
            //
            //     // больше ничего не делаем
            //     return false;
            //
            // } else {
            //
            //     // выключаем радио кнопку, т.к. пункт самовывоза пока не выбран
            //     $('#d_type7').prop('disabled', true);
            //     // вкл/выкл кнопку оформления заказа
            //     app.toggleSubmitButtonActiveState();
            //
            //     // загружаем блок
            //     app.getDeliveryCdekWidget();
            // }

            // всегда заново инициализируем СДЭК,
            // чтобы при выборе доставки Москва/не Москва всегда заново создавался виджет, и все события срабатывали заново

            // выключаем радио кнопку, т.к. пункт самовывоза пока не выбран
            $('#d_type7').prop('disabled', true);
            // вкл/выкл кнопку оформления заказа
            app.toggleSubmitButtonActiveState();

            // загружаем блок
            app.getDeliveryCdekWidget();

        },

        hideDeliveryCdekWidget: function() {
            var deliveryCdekBlock = $('#js_shop-order__delivery-cdek');

            // очищаю поле с информацией о выбранном ПВЗ
            $('#customer_address_cdek').val('');

            deliveryCdekBlock.hide();

            // активирую радио-кнопку СДЭК, если доставка СДЭКом доступна в заказе
            $('#d_type7.js_d_type_allowed').prop('disabled', false);
        },

        getDeliveryCdekWidget: function() {

            // скрипт должен быть загружен в исходном коде, т.к. виджет ищет тег <script id="ISDEKscript"
            // if(!app.ISDEKWidjet) {
            //     $.ajax({
            //         url: app.cdekWidgetScriptUrl,
            //         dataType: "script",
            //         success: function () {
            //             app.ISDEKWidjet = ISDEKWidjet;
            //             app.deliveryCdekMapInit();
            //         }
            //     });
            // } else {
            //     app.deliveryCdekMapInit();
            // }

            app.deliveryCdekMapInit();

        },

        deliveryCdekMapInit: function() {

            var deliveryCdekBlock = $('#js_shop-order__delivery-cdek'),
                deliveryCdekInfo = $('#js_shop-order__delivery-cdek-info'),
                deliveryCdekMap = $('#js_shop-order__delivery-cdek-map'),
                order_id = parseInt( $('#js-order-id').val(), 10 ),
                d_type_is_free = !!$("#d_type7").attr('data-is-free'),
                loader = $('#js_overlay_loader');

            // добавляем сообщение, что надо подождать
            deliveryCdekInfo
                .html('')
                .append('<div class="alert alert-info">СДЭК загружается. Пожалуйста, подождите.</div>')
                .stop(true, true).slideDown('fast');

            loader.show();

            $.ajax({
                type: 'get',
                url: '/core/ajax/get_cart_items_for_cdek.php',
                data: {
                    order_id: order_id,
                },
                dataType: 'json',
                success: function(data){

                    if(data.success) {

                        // отмечаем, что блок загружен
                        app.deliveryCdekInitialised = true;
                        // разворачиваем блок
                        deliveryCdekBlock.show();
                        deliveryCdekMap.show();

                        var cdekWidjet = new ISDEKWidjet ({
                            showWarns: false,
                            showErrors: true,
                            showLogs: false,
                            hideMessages: false,
                            hidedelt: true, // чтобы скрыть панель, на которой отображены варианты доставки, т.к. только самовывоз из ПВЗ
                            // defaultCity: 'Москва', //какой город отображается по умолчанию
                            // defaultCity: 'auto', // чтобы автоматом показывался город покупателя
                            cityFrom: 'Москва', // из какого города будет идти доставка
                            country: 'Россия', // можно выбрать страну, для которой отображать список ПВЗ
                            link: 'js_shop-order__delivery-cdek-map', // id элемента страницы, в который будет вписан виджет
                            // path: 'https://widget.cdek.ru/widget/scripts/', //директория с библиотеками виджета
                            // servicepath: '/templates/itp/cdek/scripts/service.php', //ссылка на файл service.php на вашем сайте
                            apikey: '8859bbcc-6c02-4f60-ba9a-e3345e0f3421', // ключ для корректной работы Яндекс.Карт

                            goods: data.goods,

                            onReady: onReady,
                            onChoose: onChoose,
                            // onChooseProfile: onChooseProfile,
                            onCalculate: onCalculate
                        });

                        // после загрузки виджета
                        function onReady() {
                            // добавляем сообщение о необходимости выбрать пункт
                            deliveryCdekInfo.html('<div class="alert alert-warning">Выберите пункт выдачи СДЭК.</div>');
                        }

                        // при выборе ПВЗ
                        function onChoose(wat) {

                            // проверка на всякий случай, если вдруг будет косяк в виджете
                            if (!wat.price) {

                                // добавляем сообщение, что доставка невозможна
                                deliveryCdekInfo
                                    .html('<div class="alert alert-danger">Доставка СДЭК невозможна. Пожалуйста выберите другой способ доставки.</div>')
                                    .stop(true, true).slideDown('fast');

                                return false;
                            }

                            if (d_type_is_free) {
                                wat.price = 0
                            }

                            // включаем радио-кнопку
                            $('#d_type7')
                                .prop('disabled', false)
                                .prop('checked', true)
                            ;

                            // вкл/выкл кнопку оформления заказа
                            app.toggleSubmitButtonActiveState();

                            // формируем информацию о выбранном ПВЗ
                            var deliveryInfo = [];
                            // deliveryInfo.push('Выбран пункт выдачи заказа "' + wat.PVZ.Name + '" (' + wat.id + ').');
                            deliveryInfo.push('Выбран пункт выдачи заказа "' + wat.PVZ.Name + '".');
                            deliveryInfo.push('Адрес: ' + wat.cityName + ', ' + wat.PVZ.Address + '.');
                            if(wat.PVZ.AddressComment) {
                                deliveryInfo.push('Как найти: ' + wat.PVZ.AddressComment);
                            }
                            deliveryInfo.push('Режим работы: ' + wat.PVZ.WorkTime + '.');
                            deliveryInfo.push('Стоимость доставки: ' + wat.price + ' руб.');
                            deliveryInfo.push('Срок доставки: ' + wat.term + ' дн.');

                            // добавляем сообщение с информацией о выбранном ПВЗ
                            deliveryCdekInfo
                                .html
                                (
                                    '<div class="alert alert-success">'+
                                    deliveryInfo.join('<br>') +
                                    '</div>'
                                )
                                .stop(true, true).slideDown('fast');

                            // прописываем информацию о выбранном ПВЗ
                            $('#customer_address_cdek').val(deliveryInfo.join("\n"));

                            // сохраняем стоимость доставки
                            $('#js-shop-order__cdek-delivery-price').val(wat.price);

                            // прописываем стоимость доставки, считаем сумму заказа с доставкой
                            var delivery_price = wat.price,
                                decimals = parseInt($('#show_decimals').val());
                            var result_summ = Number(delivery_price) + Number($('#js_cart_total_summ').html());
                            if (decimals) {
                                result_summ = (Math.round(result_summ * 100) / 100).toFixed(decimals);
                            } else {
                                result_summ = Math.round(result_summ);
                            }
                            result_summ = String(result_summ).replace('.00', '');
                            $('#js_resultsumm').html(result_summ);
                            $('#js-shop-order__delivery-value').text( wat.price + ' руб.' );
                        }

                        // function onChooseProfile(wat) {
                        //     console.log(wat);
                        //     console.log(
                        //         'Выбрана доставка курьером в город ' + wat.cityName + ', код города ' + wat.city + "\n" +
                        //         'цена ' + wat.price + "\n" +
                        //         'срок ' + wat.term + ' дн.'
                        //     );
                        // }

                        // после расчета стоимости. срабатывает каждый раз при выборе города
                        function onCalculate(wat) {
                            // если СДЭК уже не выбран в момент окончания расчета стоимости
                            if ( !$('#d_type7:checked').length ) {
                                // ничего не делаем
                                return false;
                            }

                            // выключаем радио кнопку СДЭК, т.к. пункт самовывоза пока не выбран
                            $('#d_type7').prop('disabled', true);

                            // вкл/выкл кнопку оформления заказа
                            app.toggleSubmitButtonActiveState();

                            // добавляем сообщение о необходимости выбрать пункт
                            deliveryCdekInfo.html('<div class="alert alert-warning">Выберите пункт выдачи СДЭК.</div>');

                            // сбрасываем сохраненную стоимость доставки
                            $('#js-shop-order__cdek-delivery-price').val(0);

                            // если нет цены за самовывоз, значит "Невозможно осуществить доставку по этому направлению при заданных условиях"
                            if (!wat.profiles.pickup.price) {

                                // снимаем выделение со способа доставки СДЭК и скрываем способ
                                $('#d_type7')
                                    .prop('checked', false)
                                    .closest('.js-shop-order__delivery-type').hide();

                                // вкл/выкл кнопку оформления заказа
                                app.toggleSubmitButtonActiveState();

                                // скрываем блок с картой
                                deliveryCdekMap.stop(true, true).slideUp('fast');

                                // добавляем сообщение, что доставка невозможна
                                deliveryCdekInfo
                                    .html('<div class="alert alert-danger">Доставка СДЭК невозможна. Пожалуйста выберите другой способ доставки.</div>')
                                    .stop(true, true).slideDown('fast');

                            } else {

                                // прописываем стоимость доставки, считаем сумму заказа с доставкой
                                var delivery_price = wat.profiles.pickup.price,
                                    decimals = parseInt($('#show_decimals').val());

                                if (d_type_is_free) {
                                    delivery_price = 0
                                }
                                var result_summ = Number(delivery_price) + Number($('#js_cart_total_summ').html());
                                if (decimals) {
                                    result_summ = (Math.round(result_summ * 100) / 100).toFixed(decimals);
                                } else {
                                    result_summ = Math.round(result_summ);
                                }
                                result_summ = String(result_summ).replace('.00', '');
                                $('#js_resultsumm').html(result_summ);
                                $('#js-shop-order__delivery-value').text( delivery_price + ' руб.' );
                            }

                        }
                    }

                    if(data.error) {
                        // разворачиваем, чтобы отобразить сообщение об ошибке.
                        deliveryCdekBlock.show();
                        deliveryCdekMap.hide();

                        deliveryCdekInfo
                            .html('<div class="alert alert-danger">'+data.message+'</div>')
                            .stop(true, true).slideDown('fast');

                        console.log('get_cart_items_for_cdek error', data.message);
                    }
                },
                complete: function(){
                    loader.hide();
                }
            });
        },

        showDeliveryCourierMap: function() {

            var deliveryCourierModeSelect = $('#js_shop-order__delivery-courier-mode-select'),
                deliveryCourierMap = $('#js_shop-order__delivery-courier-map'),
                customerAddressPostcode = $('#customer_address_postcode'),
                orderContacts = $('#js-shop-order__contacts');

            deliveryCourierModeSelect.stop(true,true).slideDown('fast');

            // выключаем поле Индекс
            customerAddressPostcode
                .removeClass('js-customer-address-required') // удаляем класс обязательности, чтобы не участвовал в его обработке
                .val('') // удаляем значение
                .prop('required', false) // выключаем обязательность
                .closest('.js-shop-order__contacts-col').hide(); // скрываем родительский блок

            // чтобы применять стили
            orderContacts.addClass('shop-order__contacts_courier');

            // чтобы стилями менять порядок полей и карты
            if ( $('.js-shop-order__delivery-courier-btn.active[data-address-mode="map"]').length ) {
                orderContacts
                    .addClass('shop-order__contacts_courier-map')
                    .removeClass('shop-order__contacts_courier-input');
            } else {
                orderContacts
                    .addClass('shop-order__contacts_courier-input')
                    .removeClass('shop-order__contacts_courier-map');
            }

            // если блок курьерской доставки уже был инициализирован (загружен)
            if (app.deliveryCourierInitialised) {

                // разворачиваем блок
                deliveryCourierMap.show();

                // больше ничего не делаем
                return false;

            } else {
                // иначе загружаем блок
                app.getDeliveryCourierMap();
            }
        },

        hideDeliveryCourierMap: function(INPUT) {

            var deliveryCourierModeSelect = $('#js_shop-order__delivery-courier-mode-select'),
                deliveryCourierMap = $('#js_shop-order__delivery-courier-map'),
                customerAddressPostcode = $('#customer_address_postcode'),
                orderContacts = $('#js-shop-order__contacts');

            deliveryCourierModeSelect.stop(true,true).slideUp('fast');
            deliveryCourierMap.hide();

            // возвращаем поле Индекс
            customerAddressPostcode
                .addClass('js-customer-address-required') // добавляем класс обязательности, чтобы обрабатывался
                .closest('.js-shop-order__contacts-col').show(); // отображаем родительский блок
            if ( INPUT.is('.js_address_required') ) {
                customerAddressPostcode.prop('required', true) // включаем обязательность
            }

            orderContacts
                .removeClass('shop-order__contacts_courier')
                .removeClass('shop-order__contacts_courier-map')
                .removeClass('shop-order__contacts_courier-input');

            // делаем адресные поля редактируемыми
            $('.js-customer-address-required').prop('readonly', false);
        },

        getDeliveryCourierMap: function() {

            var deliveryCourierMap = $('#js_shop-order__delivery-courier-map');

            if(!app.yandexMapsYMAPS) {
                $.ajax({
                    url: app.yandexMapsScriptUrl,
                    dataType: "script",
                    success: function () {
                        app.yandexMapsYMAPS = ymaps;
                        app.deliveryCourierMapInit();
                    }
                });
            } else {
                app.deliveryCourierMapInit();
            }

            // отмечаем, что блок загружен
            app.deliveryCourierInitialised = true;
            // разворачиваем блок
            deliveryCourierMap.show();
        },

        deliveryCourierMapInit: function() {

            if(app.yandexMapsYMAPS) {

                // запускаем карту с задержкой, т.к. блок изначально скрыт
                setTimeout(function () {
                    app.yandexMapsYMAPS.ready(courierMapInit);
                }, 250);

            }

            function courierMapInit() {

                // console.log('courierMapInit');

                // отобразить блок с радио-кнопкой курьерской доставки
                // $('.js-shop-order__delivery-type[data-dtype-id="2"]').show();

                var courierMap,
                    deliveryPoint;

                var moscowCenter = [55.76, 37.64];

                var mkadZone;
                var mkadPolygon;
                var moscowJSON = { "type": "Polygon", "coordinates": [[[55.78000432402266,37.84172564285271],[55.775874525970494,37.8381207618713],[55.775626746008065,37.83979446823122],[55.77446586811748,37.84243326983639],[55.771974101091104,37.84262672750849],[55.77114545193181,37.84153238623039],[55.76722010265554,37.841124690460184],[55.76654891107098,37.84239076983644],[55.76258709833121,37.842283558197025],[55.758073999993734,37.8421759312134],[55.75381499999371,37.84198330422974],[55.749277102484484,37.8416827275085],[55.74794544108413,37.84157576190186],[55.74525257875241,37.83897929098507],[55.74404373042019,37.83739676451868],[55.74298009816793,37.838732481460525],[55.743060321833575,37.841183997352545],[55.73938799999373,37.84097476190185],[55.73570799999372,37.84048155819702],[55.73228210777237,37.840095812164286],[55.73080491981639,37.83983814285274],[55.729799917464675,37.83846476321406],[55.72919751082619,37.83835745269769],[55.72859509486539,37.838636380279524],[55.727705075632784,37.8395161005249],[55.722727886185154,37.83897964285276],[55.72034817326636,37.83862557539366],[55.71944437307499,37.83559735744853],[55.71831419154461,37.835370708803126],[55.71765218986692,37.83738169402022],[55.71691750159089,37.83823396494291],[55.71547311301385,37.838056931213345],[55.71221445615604,37.836812846557606],[55.709331054395555,37.83522525396725],[55.70953687463627,37.83269301586908],[55.70903403789297,37.829667367706236],[55.70552351822608,37.83311126588435],[55.70041317726053,37.83058993121339],[55.69883771404813,37.82983872750851],[55.69718947487017,37.82934501586913],[55.69504441658371,37.828926414016685],[55.69287499999378,37.82876530422971],[55.690759754047335,37.82894754100031],[55.68951421135665,37.827697554878185],[55.68965045405069,37.82447346292115],[55.68322046195302,37.83136543914793],[55.67814012759211,37.833554015869154],[55.67295011628339,37.83544184655761],[55.6672498719639,37.837480388885474],[55.66316274139358,37.838960677246064],[55.66046999999383,37.83926093121332],[55.65869897264431,37.839025050262435],[55.65794084879904,37.83670784390257],[55.65694309303843,37.835656529083245],[55.65689306460552,37.83704060449217],[55.65550363526252,37.83696819873806],[55.65487847246661,37.83760389616388],[55.65356745541324,37.83687972750851],[55.65155951234079,37.83515216004943],[55.64979413590619,37.83312418518067],[55.64640836412121,37.82801726983639],[55.64164525405531,37.820614174591],[55.6421883258084,37.818908190475426],[55.64112490388471,37.81717543386075],[55.63916106913107,37.81690987037274],[55.637925371757085,37.815099354492155],[55.633798276884455,37.808769150787356],[55.62873670012244,37.80100123544311],[55.62554336109055,37.79598013491824],[55.62033499605651,37.78634567724606],[55.618768681480326,37.78334147619623],[55.619855533402706,37.77746201055901],[55.61909966711279,37.77527329626457],[55.618770300976294,37.77801986242668],[55.617257701952106,37.778212973541216],[55.61574504433011,37.77784818518065],[55.61148576294007,37.77016867724609],[55.60599579539028,37.760191219573976],[55.60227892751446,37.75338926983641],[55.59920577639331,37.746329965606634],[55.59631430313617,37.73939925396728],[55.5935318803559,37.73273665739439],[55.59350760316188,37.7299954450912],[55.59469840523759,37.7268679946899],[55.59229549697373,37.72626726983634],[55.59081598950582,37.7262673598022],[55.5877595845419,37.71897193121335],[55.58393177431724,37.70871550793456],[55.580917323756644,37.700497489410374],[55.57778089778455,37.69204305026244],[55.57815154690915,37.68544477378839],[55.57472945079756,37.68391050793454],[55.57328235936491,37.678803592590306],[55.57255251445782,37.6743402539673],[55.57216388774464,37.66813862698363],[55.57505691895805,37.617927457672096],[55.5757737568051,37.60443099999999],[55.57749105910326,37.599683515869145],[55.57796291823627,37.59754177842709],[55.57906686095235,37.59625834786988],[55.57746616444403,37.59501783265684],[55.57671634534502,37.593090671936025],[55.577944600233785,37.587018007904],[55.57982895000019,37.578692203704804],[55.58116294118248,37.57327546607398],[55.581550362779,37.57385012109279],[55.5820107079112,37.57399562266922],[55.58226289171689,37.5735356072979],[55.582393529795155,37.57290393054962],[55.581919415056234,37.57037722355653],[55.584471614867844,37.5592298306885],[55.58867650795186,37.54189249206543],[55.59158133551745,37.5297256269836],[55.59443656218868,37.517837865081766],[55.59635625174229,37.51200186508174],[55.59907823904434,37.506808949737554],[55.6062944994944,37.49820432275389],[55.60967103463367,37.494406071441674],[55.61066689753365,37.494760001358024],[55.61220931698269,37.49397137107085],[55.613417718449064,37.49016528606031],[55.61530616333343,37.48773249206542],[55.622640129112334,37.47921386508177],[55.62993723476164,37.470652153442394],[55.6368075123157,37.46273446298218],[55.64068225239439,37.46350692265317],[55.640794546982576,37.46050283203121],[55.64118904154646,37.457627470916734],[55.64690488145138,37.450718034393326],[55.65397824729769,37.44239252645875],[55.66053543155961,37.434587576721185],[55.661693766520735,37.43582144975277],[55.662755031737014,37.43576786245721],[55.664610641628116,37.430982915344174],[55.66778515273695,37.428547447097685],[55.668633314343566,37.42945134592044],[55.66948145750025,37.42859571562949],[55.670813882451405,37.4262836402282],[55.6811141674414,37.418709037048295],[55.68235377885389,37.41922139651101],[55.68359335082235,37.419218771842885],[55.684375235224735,37.417196501327446],[55.68540557585352,37.41607020370478],[55.68686637150793,37.415640857147146],[55.68903015131686,37.414632153442334],[55.690896881757396,37.413344899475064],[55.69264232162232,37.41171432275391],[55.69455101638112,37.40948282275393],[55.69638690385348,37.40703674603271],[55.70451821283731,37.39607169577025],[55.70942491932811,37.38952706878662],[55.71149057784176,37.387778313491815],[55.71419814298992,37.39049275399779],[55.7155489617061,37.385557272491454],[55.71849856042102,37.38388335714726],[55.7292763261685,37.378368238098155],[55.730845879211614,37.37763597123337],[55.73167906388319,37.37890062088197],[55.734703664681774,37.37750451918789],[55.734851959522246,37.375610832015965],[55.74105626086403,37.3723813571472],[55.746115620904355,37.37014935714723],[55.750883999993725,37.36944173016362],[55.76335905525834,37.36975304365541],[55.76432079697595,37.37244070571134],[55.76636979670426,37.3724259757175],[55.76735417953104,37.369922155757884],[55.76823419316575,37.369892695770275],[55.782312184391266,37.370214730163575],[55.78436801120489,37.370493611114505],[55.78596427165359,37.37120164550783],[55.7874378183096,37.37284851456452],[55.7886695054807,37.37608325135799],[55.78947647305964,37.3764587460632],[55.79146512926804,37.37530000265506],[55.79899647809345,37.38235915344241],[55.80113596939471,37.384344043655396],[55.80322699999366,37.38594269577028],[55.804919036911976,37.38711208598329],[55.806610999993666,37.3880239841309],[55.81001864976979,37.38928977249147],[55.81348641242801,37.39038389947512],[55.81983538336746,37.39235781481933],[55.82417822811877,37.393709457672124],[55.82792275755836,37.394685720901464],[55.830447148154136,37.39557615344238],[55.83167107969975,37.39844478226658],[55.83151823557964,37.40019761214057],[55.83264967594742,37.400398790382326],[55.83322180909622,37.39659544313046],[55.83402792148566,37.39667059524539],[55.83638877400216,37.39682089947515],[55.83861656112751,37.39643489154053],[55.84072348043264,37.3955338994751],[55.84502158126453,37.392680272491454],[55.84659117913199,37.39241188227847],[55.84816071336481,37.392529730163616],[55.85288092980303,37.39486835714723],[55.859893456073635,37.39873052645878],[55.86441833633205,37.40272161111449],[55.867579567544375,37.40697072750854],[55.868369880337,37.410007082016016],[55.86920843741314,37.4120992989502],[55.87055369615854,37.412668021163924],[55.87170587948249,37.41482461111453],[55.873183961039565,37.41862266137694],[55.874879126654704,37.42413732540892],[55.875614937236705,37.4312182698669],[55.8762723478417,37.43111093783558],[55.87706546369396,37.43332105622856],[55.87790681284802,37.43385747619623],[55.88027084462084,37.441303050262405],[55.87942070143253,37.44747234260555],[55.88072960917233,37.44716141796871],[55.88121221323979,37.44769797085568],[55.882080694420715,37.45204320500181],[55.882346110794586,37.45673176190186],[55.88252729504517,37.463383999999984],[55.88294937719063,37.46682797486874],[55.88361266759345,37.470014457672086],[55.88546991372396,37.47751410450743],[55.88534929207307,37.47860317658232],[55.882563306475106,37.48165826025772],[55.8815803226785,37.48316434442331],[55.882427612793315,37.483831555817645],[55.88372791409729,37.483182967125686],[55.88495581062434,37.483092277908824],[55.8875561994203,37.4855716508179],[55.887827444039566,37.486440636245746],[55.88897899871799,37.49014203439328],[55.890208937135604,37.493210285705544],[55.891342397444696,37.497512451065035],[55.89174030252967,37.49780744510645],[55.89239745507079,37.49940333499519],[55.89339220941865,37.50018383334346],[55.903869074155224,37.52421672750851],[55.90564076517974,37.52977457672118],[55.90661661218259,37.53503220370484],[55.90714113744566,37.54042858064267],[55.905645048442985,37.54320461007303],[55.906608607018505,37.545686966066306],[55.90788552162358,37.54743976120755],[55.90901557907218,37.55796999999999],[55.91059395704873,37.572711542327866],[55.91073854155573,37.57942799999998],[55.91009969268444,37.58502865872187],[55.90794809960554,37.58739968913264],[55.908713267595054,37.59131567193598],[55.902866854295375,37.612687423278814],[55.90041967242986,37.62348079629517],[55.898141151686396,37.635797880950896],[55.89639275532968,37.649487626983664],[55.89572360207488,37.65619302513125],[55.895295577183965,37.66294133862307],[55.89505457604897,37.66874564418033],[55.89254677027454,37.67375601586915],[55.8947775867987,37.67744661901856],[55.89450045676125,37.688347],[55.89422926332761,37.69480554232789],[55.89322256101114,37.70107096560668],[55.891763491662616,37.705962965606716],[55.889110234998974,37.711885134918205],[55.886577568759876,37.71682005026245],[55.88458159806678,37.7199315476074],[55.882281005794134,37.72234560316464],[55.8809452036196,37.72364385977171],[55.8809722706006,37.725371142837474],[55.88037213862385,37.727870902099546],[55.877941504088696,37.73394330422971],[55.87208120378722,37.745339592590376],[55.86703807949492,37.75525267724611],[55.859821640197474,37.76919976190188],[55.82962968399116,37.827835219574],[55.82575289922351,37.83341438888553],[55.82188784027888,37.83652584655761],[55.81612575504693,37.83809213491821],[55.81460347077685,37.83605359521481],[55.81276696067908,37.83632178569025],[55.811486181656385,37.838623105812026],[55.807329380532785,37.83912198147584],[55.80510270463816,37.839079078033414],[55.79940712529036,37.83965844708251],[55.79131399999368,37.840581150787344],[55.78000432402266,37.84172564285271]]] };

                var deliveryZone;
                var deliveryPolygon;

                // многоугольник из конструктора карт описывающий зону доставки с запасом в координатах longlat (почему-то в этом формате экспортируется )
                var deliveryZoneJSON = {"type":"Polygon", "coordinates": [[[37.26052206954476,56.18659630990792],[36.8320552726697,55.91916128193096],[36.82106894454477,55.56434745288236],[37.277001561732185,55.31608250528933],[37.96090048751359,55.311383175872265],[38.41957968673223,55.565903907148254],[38.4250728507949,55.91761891375958],[37.966393651575906,56.182001127344456],[37.26052206954476,56.18659630990792]]] };

                // конвертирую longlat в latlong
                for (var i = 0; i < deliveryZoneJSON.coordinates[0].length; i++) {
                    deliveryZoneJSON.coordinates[0][i] = [deliveryZoneJSON.coordinates[0][i][1],deliveryZoneJSON.coordinates[0][i][0]]
                }

                var inputSearchTimeout = null;

                var routeObjects,
                    routePaths;

                // var geolocation = ymaps.geolocation;

                courierMap = new ymaps.Map('js_shop-order__delivery-courier-map', {
                    center: moscowCenter, // Москва
                    zoom: 10,
                    controls: ['zoomControl', 'fullscreenControl'],
                }, {
                    searchControlProvider: 'yandex#search',
                });

                deliveryPoint = new ymaps.GeoObject({
                    geometry: {type: 'Point'},
                    properties: {iconCaption: 'Адрес'}
                }, {
                    preset: 'islands#blackDotIconWithCaption',
                    // draggable: true,
                    // iconCaptionMaxWidth: '215'
                });

                courierMap.geoObjects.add(deliveryPoint);

                // // Проверим попадание результата поиска в одну из зон доставки.
                // searchControl.events.add('resultshow', function (e) {
                //     highlightResult(searchControl.getResultsArray()[e.get('index')]);
                // });

                // // Проверим попадание метки геолокации в одну из зон доставки.
                // courierMap.controls.get('geolocationControl').events.add('locationchange', function (e) {
                //     highlightResult(e.get('geoObjects').get(0));
                // });

                // При перемещении метки сбрасываем подпись, содержимое балуна и перекрашиваем метку.
                deliveryPoint.events.add('dragstart', function () {
                    deliveryPoint.properties.set({iconCaption: '', balloonContent: ''});
                    deliveryPoint.options.set('iconColor', 'black');
                });

                // По окончании перемещения ищем адрес по координатам
                deliveryPoint.events.add('dragend', function () {

                    var coords = deliveryPoint.geometry.getCoordinates();

                    deliveryPoint.properties.set('iconCaption', 'Поиск...');

                    // courierMap.panTo(coords);

                    ymaps.geocode(coords).then(function (res) {
                        var firstGeoObject;

                        if(res.geoObjects) {
                            firstGeoObject = res.geoObjects.get(0);
                        }

                        highlightResult(firstGeoObject, true);
                    });
                });

                // // Сравним положение, вычисленное по ip пользователя и
                // // положение, вычисленное средствами браузера.
                // geolocation.get({
                //     provider: 'yandex',
                //     mapStateAutoApply: true
                // }).then(function (result) {
                //     // Красным цветом пометим положение, вычисленное через ip.
                //     result.geoObjects.options.set('preset', 'islands#redIcon');
                //     result.geoObjects.get(0).properties.set({
                //         balloonContentBody: 'Мое местоположение'
                //     });
                //     courierMap.geoObjects.add(result.geoObjects);
                // });
                //
                // geolocation.get({
                //     provider: 'browser',
                //     mapStateAutoApply: true
                // }).then(function (result) {
                //     // Синим цветом пометим положение, полученное через браузер.
                //     // Если браузер не поддерживает эту функциональность, метка не будет добавлена на карту.
                //     result.geoObjects.options.set('preset', 'islands#blueIcon');
                //     courierMap.geoObjects.add(result.geoObjects);
                // });

                // ymaps.regions.load('RU', {
                //     lang: 'en'
                // }).then(function (result) {
                //     geoMap.geoObjects.add(result.geoObjects);
                // });

                mkadPolygon = new ymaps.Polygon(moscowJSON.coordinates);
                // Если мы не хотим, чтобы контур был виден, зададим соответствующую опцию.
                mkadPolygon.options.set('visible', false);
                // mkadPolygon.options.set('fillOpacity', 0.2);
                // Чтобы корректно осуществлялись геометрические операции
                // над спроецированным многоугольником, его нужно добавить на карту.
                courierMap.geoObjects.add(mkadPolygon);

                // формируем GeoQueryResult из одиночного геообъекта //https://tech.yandex.ru/maps/jsapi/doc/2.1/ref/reference/GeoQueryResult-docpage/
                mkadZone = ymaps.geoQuery(mkadPolygon);


                // формируем зону доставки
                deliveryPolygon = new ymaps.Polygon(deliveryZoneJSON.coordinates);
                deliveryPolygon.options.set('visible', false);
                courierMap.geoObjects.add(deliveryPolygon);
                deliveryZone = ymaps.geoQuery(deliveryPolygon);

                // если выбран способ "Ввести адрес"
                if( $('.js-shop-order__delivery-courier-btn.active[data-address-mode="input"]').length ) {
                    searchAddressFromInputs();
                } else {

                    prepareToShowOnMap();
                }

                // $(document).on('click', '.js_d_type', function () { // при выборе способа доставки
                //     var INPUT = $(this),
                //         d_type = parseInt(INPUT.val(), 10);
                //
                //     var deliveryCourierModeSelect = $('#js_shop-order__delivery-courier-mode-select'),
                //         deliveryCourierMap = $('#js_shop-order__delivery-courier-map'),
                //         customerAddressPostcode = $('#customer_address_postcode'),
                //         orderContacts = $('#js-shop-order__contacts');
                //
                //     // если доставка курьером
                //     if (d_type === 2) {
                //         deliveryCourierModeSelect.stop(true,true).slideDown('fast');
                //         deliveryCourierMap.show();
                //
                //         // обязательно надо обновить вьюпорт карты и установить зум, т.к. блок изначально скрыт
                //         setTimeout(function () {
                //             courierMap.container.fitToViewport();
                //         }, 250);
                //
                //         // выключаем поле Индекс
                //         customerAddressPostcode
                //             .removeClass('js-customer-address-required') // удаляем класс обязательности, чтобы не участвовал в его обработке
                //             .val('') // удаляем значение
                //             .prop('required', false) // выключаем обязательность
                //             .closest('.js-shop-order__contacts-col').hide(); // скрываем родительский блок
                //
                //         orderContacts.addClass('shop-order__contacts_courier');
                //         if ( $('.js-shop-order__delivery-courier-btn.active[data-address-mode="map"]').length ) {
                //             orderContacts
                //                 .addClass('shop-order__contacts_courier-map')
                //                 .removeClass('shop-order__contacts_courier-input');
                //         } else {
                //             orderContacts
                //                 .addClass('shop-order__contacts_courier-input')
                //                 .removeClass('shop-order__contacts_courier-map');
                //         }
                //
                //         // если выбран способ "Ввести адрес"
                //         if( $('.js-shop-order__delivery-courier-btn.active[data-address-mode="input"]').length ) {
                //             searchAddressFromInputs();
                //         } else {
                //
                //             prepareToShowOnMap();
                //         }
                //
                //     } else {
                //         deliveryCourierModeSelect.stop(true,true).slideUp('fast');
                //         deliveryCourierMap.hide();
                //
                //         // возвращаем поле Индекс
                //         customerAddressPostcode
                //             .addClass('js-customer-address-required') // добавляем класс обязательности, чтобы обрабатывался
                //             .closest('.js-shop-order__contacts-col').show(); // отображаем родительский блок
                //         if ( INPUT.is('.js_address_required') ) {
                //             customerAddressPostcode.prop('required', true) // включаем обязательность
                //         }
                //
                //         orderContacts
                //             .removeClass('shop-order__contacts_courier')
                //             .removeClass('shop-order__contacts_courier-map')
                //             .removeClass('shop-order__contacts_courier-input');
                //
                //         // делаем адресные поля редактируемыми
                //         $('.js-customer-address-required').prop('readonly', false);
                //     }
                // });

                $(document).on('input', '#customer_address_city, #customer_address_address, #customer_address_building', function () { // при вводе данных в адресные поля

                    if(inputSearchTimeout) {
                        clearTimeout(inputSearchTimeout);
                    }

                    inputSearchTimeout = setTimeout(function () {
                        searchAddressFromInputs();
                    }, 1000);

                });

                $(document).on('click', '.js-shop-order__delivery-courier-btn', function () { // при выборе режима ввода адреса для курьерской доставки
                    var btn = $(this),
                        mode = btn.attr('data-address-mode'),
                        orderContacts = $('#js-shop-order__contacts');

                    var customerAddressCity = $('#customer_address_city');

                    // переключаем класс кнопки
                    btn
                        .addClass('active')
                        .siblings().removeClass('active');

                    // если "Указать на карте"
                    if (mode === 'map') {

                        deliveryPoint.options.set('draggable', true);

                        // Обработка события, возникающего при щелчке
                        // левой кнопкой мыши в любой точке карты.
                        // При возникновении двигаем метку на точку.
                        courierMap.events.add('click', clickOnCourierMap);

                        orderContacts
                            .addClass('shop-order__contacts_courier-map')
                            .removeClass('shop-order__contacts_courier-input');

                        // // скрываем ненужные поля
                        // customerAddressCity
                        //     .removeClass('js-customer-address-required')
                        //     .prop('required', false)
                        //     .closest('.js-shop-order__contacts-col').hide();

                        // делаем адресные поля только для чтения
                        $('.js-customer-address-required').prop('readonly', true);

                        prepareToShowOnMap();
                    } else {

                        deliveryPoint.options.set('draggable', false);

                        // убираем обработку события клика
                        courierMap.events.remove('click', clickOnCourierMap);

                        orderContacts
                            .addClass('shop-order__contacts_courier-input')
                            .removeClass('shop-order__contacts_courier-map');

                        // // отображаем скрытые поля
                        // customerAddressCity
                        //     .addClass('js-customer-address-required')
                        //     .prop('required', true)
                        //     .closest('.js-shop-order__contacts-col').show();

                        // делаем адресные поля редактируемыми
                        $('.js-customer-address-required').prop('readonly', false);

                        searchAddressFromInputs();
                    }
                });

                function clickOnCourierMap(e) {

                    var coords = e.get('coords');

                    // Перемещаем метку в координаты клика
                    deliveryPoint.geometry.setCoordinates(coords);
                    deliveryPoint.properties.set('iconCaption', 'Поиск...');

                    // courierMap.panTo(coords);

                    // console.log('clickOnCourierMap');

                    ymaps.geocode(coords).then(function (res) {
                        // console.log('ymaps.geocode(coords) clickOnCourierMap');
                        var firstGeoObject = res.geoObjects.get(0);

                        highlightResult(firstGeoObject, true);
                    });
                }

                function searchAddressFromInputs() {
                    // ищем на карте адрес, введенный в адресные поля, если они заполнены

                    // если Город получения заказа - не Москва
                    if ( !$('#delivery-city_moscow:checked').length ) {
                        // ничего искать не надо
                        return false;
                    }

                    // убираем ограниченную область для карты
                    courierMap.options.set('restrictMapArea', false);

                    var cityString = $('#customer_address_city').val();
                    var streetString = $('#customer_address_address').val();
                    var buildingString = $('#customer_address_building').val();

                    var addressString = [cityString, streetString, buildingString].join(' ').trim();

                    if(!cityString || !streetString || !buildingString || !addressString) {

                        // скрываем метку, блокируем оформление заказа
                        deliveryPoint.options.set('visible', false);
                        // $('#d_type2').prop('checked', false);
                        $('#js-shop-order__delivery-value').text('нужен расчет');
                        app.toggleSubmitButtonActiveState();

                        return false;
                    }

                    // Поиск адреса.
                    ymaps.geocode(addressString, {
                        /**
                         * Опции запроса
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/geocode.xml
                         */
                        // Сортировка результатов от центра окна карты.
                        // boundedBy: courierMap.getBounds(),
                        // strictBounds: true,
                        // Вместе с опцией boundedBy будет искать строго внутри области, указанной в boundedBy.
                        // Если нужен только один результат, экономим трафик пользователей.
                        results: 1
                    }).then(function (res) {

                        // Выбираем первый результат геокодирования.
                        // console.log('searchAddressFromInputs');
                        var firstGeoObject = res.geoObjects.get(0);

                        // // Координаты геообъекта.
                        // coords = firstGeoObject.geometry.getCoordinates(),
                        // // Область видимости геообъекта.
                        // bounds = firstGeoObject.properties.get('boundedBy');

                        // нашли
                        if(firstGeoObject) {
                            highlightResult(firstGeoObject, false, true);
                        } else {
                            // не нашли
                            // console.log('не нашли');

                            // скрываем метку, сбрасываем выбранный способ доставки, блокируем оформление заказа
                            deliveryPoint.options.set('visible', false);
                            $('#d_type2').prop('checked', false);
                            $('#js-shop-order__delivery-value').text('нужен расчет');
                            app.toggleSubmitButtonActiveState();
                        }
                    });
                }

                function highlightResult(obj, fromMapEvent, setBounds) {

                    if(!obj) return false;

                    // console.log('Все данные геообъекта: ', obj.properties.getAll());

                    fromMapEvent = typeof fromMapEvent  === 'undefined' ? false : fromMapEvent;
                    setBounds = typeof setBounds  === 'undefined' ? false : setBounds;

                    // Координаты геообъекта..
                    var coords = obj.geometry.getCoordinates(),

                        // Область видимости геообъекта.
                        bounds = obj.properties.get('boundedBy');

                    // Перемещаем метку с подписью в переданные координаты и включаем её
                    deliveryPoint.geometry.setCoordinates(coords);
                    deliveryPoint.options.set('visible', true);

                    if(fromMapEvent) {

                        var city = $('#customer_address_city');
                        var street = $('#customer_address_address');
                        var building = $('#customer_address_building');

                        city.val( obj.getLocalities().length ? obj.getLocalities().join(', ') : '' );
                        street.val( obj.getThoroughfare() ? obj.getThoroughfare() : 'не определено' );
                        building.val( obj.getPremiseNumber() );
                    }

                    if(setBounds) {
                        // Масштабируем карту на область видимости геообъекта.
                        courierMap.setBounds(bounds, {
                            // Проверяем наличие тайлов на данном масштабе.
                            checkZoomRange: true
                        });
                    } else {
                        courierMap.panTo(coords);
                    }

                    obj.options.set('visible', true);

                    // надо удалить маршрут, если был построен.
                    if ( routeObjects) {
                        routeObjects.removeFromMap(courierMap);
                    }
                    if ( routePaths) {
                        courierMap.geoObjects.remove(routePaths)
                    }

                    // сначала проверяем входит ли точка вообще в зону доставки
                    var coordsIsInDeliveryZone = deliveryZone.searchContaining(coords).get(0);

                    // если не входят
                    if (!coordsIsInDeliveryZone) {
                        // дальше нет смысла что-либо проверять

                        // Задаём контент балуна и метки.

                        deliveryPoint.properties.set({
                            iconCaption: 'Доставка невозможна...',
                            balloonContent: 'Доставка дальше 15 км. от МКАДа недоступна.',
                            balloonContentHeader: ''
                        });
                        // Перекрашиваем метку в чёрный цвет.
                        deliveryPoint.options.set('iconColor', 'gray');

                        $('#js-shop-order__delivery-value').text('невозможна');

                        // убираем галочку Доставка курьером
                        $('#d_type2').prop('checked', false);

                        // выключаем форму
                        app.toggleSubmitButtonActiveState();

                        return false;
                    }

                    // сначала надо проверять, входит ли точка в область МКАД
                    // если да, то сразу считаем цену доставки.
                    // иначе - делаем маршрут и считаем километраж.

                    // Проверяем входят ли переданные координаты в МКАД.
                    var coordsIsInMkad =  mkadZone.searchContaining(coords).get(0);

                    var is_in_mkad = false,
                        kilometers = 0;

                    // если найден - это наш полигон МКАД, считаем цену внутри МКАДа
                    if (coordsIsInMkad) {
                        deliveryPoint.options.set('iconColor', '#ffd644');

                        is_in_mkad = 1;

                        // Задаем подпись для метки.
                        if (typeof(obj.getThoroughfare) === 'function') {
                            setData(obj);
                        } else {
                            // Если вы не хотите, чтобы при каждом перемещении метки отправлялся запрос к геокодеру,
                            // закомментируйте код ниже.
                            ymaps.geocode(coords, {results: 1}).then(function (res) {
                                var obj = res.geoObjects.get(0);
                                setData(obj);
                            });
                        }

                        getCalcCourierDeliveryCost();
                    } else {
                        // deliveryPoint.options.set('iconColor', 'red');

                        ymaps.route([moscowCenter, coords]).then(function (res) {
                            // Объединим в выборку все сегменты маршрута.
                            routePaths = res.getPaths();

                            courierMap.geoObjects.add(routePaths);

                            // console.log('routePaths', routePaths);

                            // routePaths.each(function (path) {
                            //     console.log('path', path.getLength());
                            // });

                            var pathsObjects = ymaps.geoQuery(routePaths),
                                edges = [];

                            // console.log('getPaths', res.getPaths());

                            // res.getPaths().each(function(path) {
                            //     console.log("Длина пути: " + path.properties.get("distance").text);
                            //     console.log("Время прохождения пути: " + path.properties.get("duration").text);
                            // });

                            // Переберем все сегменты и разобьем их на отрезки.
                            pathsObjects.each(function (path) {
                                // console.log("Длина пути: " + path.properties.get("distance").text);

                                var coordinates = path.geometry.getCoordinates();
                                for (var i = 1, l = coordinates.length; i < l; i++) {
                                    edges.push({
                                        type: 'LineString',
                                        coordinates: [coordinates[i], coordinates[i - 1]],
                                    });
                                }
                            });

                            // Создадим новую выборку, содержащую:
                            // - отрезки, описываюшие маршрут;
                            // - начальную и конечную точки;
                            // - промежуточные точки.
                            routeObjects = ymaps.geoQuery(edges)
                            // .add(res.getWayPoints())
                            // .add(res.getViaPoints())
                            // .setOptions('strokeWidth', 3)
                                .setOptions('visible', false);

                            routeObjects.addToMap(courierMap);

                            var // Найдем все объекты, попадающие внутрь МКАД.
                                objectsInMoscow = routeObjects.searchInside(mkadPolygon),
                                // Найдем объекты, пересекающие МКАД.
                                boundaryObjects = routeObjects.searchIntersect(mkadPolygon),
                                // Найдем объекты, за пределами МКАД исключением полученных выборок из
                                outOfMoscow = routeObjects.remove(objectsInMoscow).remove(boundaryObjects);
                            // Раскрасим в разные цвета объекты внутри, снаружи и пересекающие МКАД.
                            // boundaryObjects.setOptions({
                            //     strokeColor: '#06ff00',
                            //     preset: 'islands#greenIcon'
                            // });
                            // objectsInMoscow.setOptions({
                            //     strokeColor: '#ff0005',
                            //     preset: 'islands#redIcon'
                            // });
                            // outOfMoscow.setOptions({
                            //     strokeColor: '#002233',
                            //     // preset: 'islands#blueIcon'
                            // });

                            outOfMoscow.each(function(path) {
                                kilometers += path.geometry.getDistance();
                            });

                            kilometers = kilometers / 1000; // переводим метры в километры

                            // console.log('kilometers', kilometers);

                            // Задаем подпись для метки.
                            if (typeof(obj.getThoroughfare) === 'function') {
                                setData(obj);
                            } else {
                                // Если вы не хотите, чтобы при каждом перемещении метки отправлялся запрос к геокодеру,
                                // закомментируйте код ниже.
                                ymaps.geocode(coords, {results: 1}).then(function (res) {
                                    var obj = res.geoObjects.get(0);
                                    setData(obj);
                                });
                            }

                            getCalcCourierDeliveryCost();
                        });

                        // // Задаём контент балуна и метки.
                        // deliveryPoint.properties.set({
                        //     iconCaption: 'Доставка транспортной компанией',
                        //     balloonContent: 'Cвяжитесь с оператором',
                        //     balloonContentHeader: ''
                        // });
                        // // Перекрашиваем метку в чёрный цвет.
                        // deliveryPoint.options.set('iconColor', 'black');
                    }

                    function getCalcCourierDeliveryCost () {

                        var
                            order_id = parseInt( $('#js-order-id').val(), 10 ),
                            pay_input_val = $('.js_pay_type:checked').val()
                        ;

                        $.ajax({
                            type: 'post',
                            url: "/core/ajax/calc_courier_delivery_cost.php",
                            dataType: 'json',
                            data: {
                                is_in_mkad: is_in_mkad,
                                kilometers: kilometers,
                                order_id: order_id,
                                pay_type: pay_input_val,
                            },
                            success: function (data) {

                                if (data.success) {

                                    // Перекрашиваем метку в желтый.
                                    deliveryPoint.options.set('iconColor', '#ffd644');

                                    var delivery_price = data.price,
                                        decimals = parseInt($('#show_decimals').val());

                                    var result_summ = Number(delivery_price) + Number($('#js_cart_total_summ').html());
                                    if (decimals) {
                                        result_summ = (Math.round(result_summ * 100) / 100).toFixed(decimals);
                                    } else {
                                        result_summ = Math.round(result_summ);
                                    }

                                    result_summ = String(result_summ).replace('.00', '');

                                    $('#js_resultsumm').html(result_summ);

                                    $('#js-shop-order__delivery-value').text( data.price_with_cur );

                                    // ставим галочку Доставка курьером
                                    $('#d_type2').prop('checked', true);

                                    // включаем форму
                                    app.toggleSubmitButtonActiveState();

                                }

                                if (data.error) {

                                    // Задаём контент балуна и метки.
                                    deliveryPoint.properties.set({
                                        iconCaption: 'Доставка невозможна...',
                                        balloonContent: data.message,
                                        balloonContentHeader: ''
                                    });
                                    // Перекрашиваем метку в чёрный цвет.
                                    deliveryPoint.options.set('iconColor', 'gray');

                                    $('#js-shop-order__delivery-value').text('невозможна');

                                    // убираем галочку Доставка курьером
                                    $('#d_type2').prop('checked', false);

                                    // выключаем форму
                                    app.toggleSubmitButtonActiveState();

                                }
                            },
                            complete: function () {
                            }
                        });
                    }

                    // function setData(obj){
                    //     var address = [obj.getThoroughfare(), obj.getPremiseNumber(), obj.getPremise()].join(' ');
                    //     if (address.trim() === '') {
                    //         address = obj.getAddressLine();
                    //     }
                    //     deliveryPoint.properties.set({
                    //         iconCaption: address,
                    //         balloonContent: address,
                    //         // balloonContentHeader: price
                    //     });
                    // }

                    function setData(obj){

                        // Название населенного пункта или вышестоящее административно-территориальное образование.
                        var location = obj.getLocalities().length ? obj.getLocalities() : obj.getAdministrativeAreas();
                        location = location[0] === 'Москва' ? '' : location;

                        deliveryPoint.properties.set({

                            // Формируем строку с данными об объекте.
                            iconCaption: [
                                location,
                                // Получаем путь до топонима, если метод вернул null, запрашиваем наименование здания.
                                obj.getThoroughfare() || obj.getPremise(),
                                // Номер дома
                                obj.getPremiseNumber()
                            ].filter(Boolean).join(', '),
                            // В качестве контента балуна задаем строку с адресом объекта.
                            balloonContent: obj.getAddressLine()
                        });
                    }
                }

                function prepareToShowOnMap() {

                    // Зададим ограниченную область прямоугольником,
                    // примерно описывающим Московскую область.
                    courierMap.options.set('restrictMapArea', [
                        [54.2997,35.1121],
                        [56.8944,40.1011]
                    ]);

                    // ставим карту в центр Москвы
                    courierMap.setCenter(moscowCenter, 10, {
                        checkZoomRange: true
                    });
                }
            }
        },

        showDeliveryPickupBlock: function() {

            // если блок самовывоза уже был инициализирован (загружен)
            if (app.deliveryPickupInitialised) {

                var deliveryPickupBlock = $('#js_shop-order__delivery-pickup');

                // разворачиваем блок
                deliveryPickupBlock.stop(true,true).slideDown('fast');

                // больше ничего не делаем
                return false;

            } else {
                // иначе загружаем блок
                app.getDeliveryPickupBlock();
            }
        },

        hideDeliveryPickupBlock: function() {
            var deliveryPickupBlock = $('#js_shop-order__delivery-pickup');

            deliveryPickupBlock.stop(true,true).slideUp('fast');
        },

        getDeliveryPickupBlock: function() {

            var deliveryPickupBlock = $('#js_shop-order__delivery-pickup'),
                order_id = deliveryPickupBlock.attr('data-order-id'),
                loader = $('#js_overlay_loader');

            loader.show();

            $.ajax({
                type: 'get',
                url: '/core/ajax/get_order_delivery_pickup.php',
                data: {
                    order_id: order_id,
                },
                dataType: 'json',
                success: function(data){

                    if(data.success) {

                        // deliveryPickupBlock.get(0).innerHTML = data.html;
                        deliveryPickupBlock.html(data.html);

                        // загружаем карту только не в мобильном
                        if ( $(window).width() >= 768 ) {

                            if(!app.yandexMapsYMAPS) {
                                $.ajax({
                                    url: app.yandexMapsScriptUrl,
                                    dataType: "script",
                                    success: function () {
                                        app.yandexMapsYMAPS = ymaps;
                                        app.deliveryPickupMapInit(data.city_center, data.markers, data.need_bounds);
                                    }
                                });
                            } else {
                                app.deliveryPickupMapInit(data.city_center, data.markers, data.need_bounds);
                            }
                        }

                        // отмечаем, что блок загружен
                        app.deliveryPickupInitialised = true;
                        // разворачиваем блок
                        deliveryPickupBlock.stop(true,true).slideDown('fast');
                    }

                    if(data.error) {

                        console.log('get_order_delivery_pickup error', data.message);

                        // $('#js-shop-order__delivery-value').text( 'нужен расчет' );
                        // messageBlock.text(data.message).show();
                    }
                },
                complete: function(){
                    loader.hide();
                }
            });
        },

        deliveryPickupMapInit: function($city_center, $markers, $need_bounds) {

            // if( typeof ymaps !== 'undefined') {
            //     ymaps.ready(init);
            // }

            if(app.yandexMapsYMAPS) {
                app.yandexMapsYMAPS.ready(init);
            }

            function init() {
                var pickupMap,
                    objectManager,
                    bounds;

                pickupMap = new ymaps.Map("shop-stores__map-yandex_order", {
                    center: [$city_center.lat,$city_center.lng],
                    zoom: 10,
                    controls: ['zoomControl', 'fullscreenControl'],
                });

                objectManager = new ymaps.ObjectManager({
                    // Чтобы метки начали кластеризоваться, выставляем опцию.
                    clusterize: true,
                    // ObjectManager принимает те же опции, что и кластеризатор.
                    preset: 'islands#invertedBrownClusterIcons',
                    clusterOpenBalloonOnClick: false,
                    gridSize: 64
                    // ,clusterDisableClickZoom: true
                });
                // pickupMap.behaviors.disable('scrollZoom');

                pickupMap.geoObjects.add(objectManager);
                objectManager.add($markers);

                if ($need_bounds) {
                    bounds = objectManager.getBounds();

                    if (bounds) {
                        pickupMap.setBounds(
                            bounds,
                            {
                                zoomMargin: 30, // отступы, чтобы все метки влезли на карту и их было видно целиком
                            }
                        );
                    }
                }

                objectManager.objects.events.add('click', onObjectClick);

                function onObjectClick (e) {
                    // id объекта совпадает с id магазина
                    var objectId = e.get('objectId');

                    // делаем клик на радиокнопке
                    $('#d_store_'+objectId).trigger('click');
                }
            }
        },

        showDeliveryDatesBlock: function() {
            // $('#js-shop-order__delivery-dates').show();
            $('#js-shop-order__delivery-dates').stop(true,true).slideDown('fast');
        },

        hideDeliveryDatesBlock: function() {
            // $('#js-shop-order__delivery-dates').hide();
            $('#js-shop-order__delivery-dates').stop(true,true).slideUp('fast');
        },

		selectPsysType: function(){ // при выборе способа оплаты

			var input = $(this),
				btn = $('#js_order_form_submit'),
				text_for_submit = input.attr('data-text-submit');

			btn.text(text_for_submit);

			app.dataLayerPushCheckoutCart(3) // шаг 3 - Способ оплаты

		},

		selectPickPoint: function(e){ // при выборе PickPoint
			e.preventDefault();
			if (typeof PickPoint != "undefined") {
				PickPoint.open(pickpoint_result);
			} else {
				$('#d_type3').prop('checked', false);
				$('#js_pickpoint_text').html('Сервис временно недоступен. Попробуйте позже.');
			}
		},

		orderContactSubmit: function(){

            var region_title = $('#customer_address_region_title'),
                region_id = $('#customer_address_region_id');

            if ( !region_id.val() ) {
                region_title.val('');
            }

			var form = $('#js-order-form');

			if(app.validateForm(form) === false) {
				$('#alert_contactdata').show();
				return false;
			} else {
				$('#alert_contactdata').hide();
			}

		},

        collapseOneShow: function(){
            //if ( $(window).width() < 768 ) {
                var offset = $('#headingOne').offset().top;
                $('html, body').animate({
                    scrollTop: offset - 60
                }, 300);
            //}
        },
        collapseTwoShow: function(){
            //if ( $(window).width() < 768 ) {
                var offset = $('#headingOne').offset().top;
                $('html, body').animate({
                    scrollTop: offset - 10
                }, 300);
            //}
        },
        collapseThreeShow: function(){
            //if ( $(window).width() < 768 ) {
                var offset = $('#headingTwo').offset().top;
                $('html, body').animate({
                    scrollTop: offset - 10
                }, 300);
            //}
        },

		orderToggleOrg: function(){

			$(this).addClass('active').removeClass('toggleorg').siblings().removeClass('active').addClass('toggleorg');
			$('#js_order_org_fileds').toggle();

			return false;

		},

		orderCalcSummAfterDelivery: function(){

		    var d_type = parseInt($(this).val(), 10);

			var delivery_price = $(this).attr('data-price'),
                decimals = parseInt($('#show_decimals').val());

            // если почта России
            if(d_type === 4) {
                delivery_price = 0;
            }

			var result_summ = Number(delivery_price) + Number($('#js_cart_total_summ').html());
            if (decimals) {
                result_summ = (Math.round(result_summ * 100) / 100).toFixed(decimals);
            } else {
                result_summ = Math.round(result_summ);
            }

            result_summ = String(result_summ).replace('.00', '');

			$('#js_resultsumm').html(result_summ);

            $('#js-shop-order__delivery-label').text( $(this).attr('data-delivery-label') );

            // если курьерская доставка, почта России или СДЭК
            if ( [2,4,7].indexOf(d_type) > -1 ) {
                $('#js-shop-order__delivery-value').text( 'нужен расчет' );
            } else {
                $('#js-shop-order__delivery-value').text( $(this).attr('data-delivery-value') );
            }

		},

        // сбрасываем все параметры, зависящие от способа доставки
        resetAllDependingOnDeliveryType: function () {
            var commentCol = $('#js-shop-order__comment-col'),
                contactsHeading = $('#js-shop-order__contacts-heading')
            ;

            // скрываем блок с выбором точки самовывоза
            $('#js_shop-order__delivery-pickup').stop(true,true).slideUp('fast');

            $('#js-shop-order__delivery-value').text('');

            // скрыть блок с рассчетом доставки Почтой России
            $('#js-shop-order__post-delivery-calc')
                .stop(true,true).slideUp('fast');

            // скрываем блок с контактами, т.к. по умолчанию будет самовывоз
            $('#js-shop-order__contacts')
                .stop(true,true).slideUp('fast')
                .find('.js-customer-address-required').prop('required', false);

            // показываем комментарий
            commentCol.hide();
            // меняем заголовок блока с контактами
            contactsHeading.text(contactsHeading.attr('data-text-common'));

            // выключаем блок с датой доставки
            app.hideDeliveryDatesBlock();

            // выключаем блок с виджетом СДЭК
            var deliveryCdekBlock = $('#js_shop-order__delivery-cdek');
            // очищаю поле с информацией о выбранном ПВЗ
            $('#customer_address_cdek').val('');
            deliveryCdekBlock.hide();
        },

		orderCalcSummAfterPayment: function(){
			var pay_input = $(this),
				pay_discount = parseInt(pay_input.attr('data-discount')),
				pay_input_val = pay_input.val(),
				decimals = parseInt($('#show_decimals').val()),
				deliveryCity = $('.js-shop-order__city:checked').val(),
                loader = $('#js_overlay_loader'),
				delivery_price,
				result_summ;

            loader.show();

            // получает доступные способы доставки
            $.ajax({
                url : "/core/ajax/order_payment_type_select.php",
                dataType : "json",
                data : {
                    city : deliveryCity,
                    pay_type : pay_input_val,
                },
                success : function(data, textStatus) {
                    if ( textStatus==='success' && data.success ){

                        var deliveryTypes = $('#js_delivery_types');

                        deliveryTypes.get(0).innerHTML = data.html;

                        app.resetAllDependingOnDeliveryType();

                        // вызываем клик на первом доступном способе доставки, если такой есть
                        deliveryTypes
                            .find(".js_d_type:not(disabled)")
                            .eq(0).trigger('click');

                        app.toggleSubmitButtonActiveState(); // включаем/выключаем кнопку Продолжить

                    } else {
                        console.log(data.message);
                    }
                },
                complete : function(){
                    loader.hide();
                }
            });

            var del_input = $('.js_d_type:checked');

			delivery_price = del_input.length ? del_input.attr('data-price') : 0;

			result_summ = Number(delivery_price) + Number($('#js_cart_total_summ').html());

			// если за этот способ оплаты есть скидка
			if (pay_discount) {
				// пересчитываем сумму заказа
				result_summ = result_summ * (100-pay_discount)/100;
				// округляем с нужной точностью
				if (decimals) {
                    result_summ = (Math.round(result_summ * 100) / 100).toFixed(decimals);
				} else {
					result_summ = Math.round(result_summ);
				}
			}

            result_summ = String(result_summ).replace('.00', '');

			$('#js_resultsumm').html(result_summ); // обновляем итоговую сумму
		},

		cartApplyCoupon: function(){

			var input = $('#js_coupon_input'),
				coupon = input.val(),
				loader = $('#js_overlay_loader');

			if(coupon){
				loader.show();
				input.removeClass('error');
				$.post("/core/ajax/cart_ajax.php", {coupon: coupon, mode: "applycoupon"}, function(){
					$.ajax({
						type: 'get',
						url: '/katalog/cart.html',
						success: function(data){
							$('.js_cart_wrapper').replaceWith($(data).find('#js_cart_wrapper'));
							$('#js_content_ajax').replaceWith($(data).find('#js_content_ajax'));
						},
						complete: function(){
							app_refresh.initialize();
							loader.hide();
						}
					});
				});
			} else {
				input.addClass('error').focus();
				input.popover({
					//title: 'Ошибка',
					content: 'Введите купон',
					//container: '.js_coupon_form_group',
					placement: 'top',
					trigger: 'focus'
				});
				input.popover('show');
			}

		},

        orderCalcPostDeliveryCost: function(){

			var loader = $('#js_overlay_loader');

			var postcode = $('#customer_address_postcode').val(),
                address = $('#customer_address_city').val() + ' ' + $('#customer_address_address').val() + ' ' + $('#customer_address_building').val(),
                order_id = parseInt( $('#js-order-id').val(), 10 ),
                pay_input_val = $('.js_pay_type:checked').val(),
                messageBlock = $('#js-shop-order__post-delivery-calc-message');

            loader.show();

            messageBlock.hide().text('');

            $.ajax({
                type: 'post',
                cache: false,
                url: '/core/ajax/calc_post_delivery_cost.php',
                data: {
                    postcode: postcode,
                    address: address,
                    order_id: order_id,
                    pay_type: pay_input_val,
                },
                success: function(data){
                    // console.log(data);

                    if(data.success) {
                        var delivery_price = data.price,
                            decimals = parseInt($('#show_decimals').val());

                        var result_summ = Number(delivery_price) + Number($('#js_cart_total_summ').html());
                        if (decimals) {
                            result_summ = (Math.round(result_summ * 100) / 100).toFixed(decimals);
                        } else {
                            result_summ = Math.round(result_summ);
                        }

                        result_summ = String(result_summ).replace('.00', '');

                        $('#js_resultsumm').html(result_summ);

                        $('#js-shop-order__delivery-value').text( data.price_with_cur );
                        $('#js-shop-order__post-delivery-calculated').val( delivery_price );
                    }

                    if(data.error) {

                        $('#js-shop-order__delivery-value').text( 'нужен расчет' );
                        messageBlock.text(data.message).show();
                    }
                },
                complete: function(){
                    loader.hide();

                    app.toggleSubmitButtonActiveState()
                }
            });

		},

		cartApplyBonuses: function(){

			var input = $('#js_use_bonuses'),
				bonuses = input.val(),
				loader = $('#js_overlay_loader');

			if(bonuses){
				loader.show();
				input.removeClass('error');
				$.post("/core/ajax/cart_ajax.php", {bonuses: bonuses, mode: "use_bonuses"}, function(){
					$.ajax({
						type: 'get',
						url: '/katalog/cart.html',
						success: function(data){
							//$('.js_cart_wrapper').replaceWith($(data).find('#js_cart_wrapper'));
							$('#js_content_ajax').replaceWith($(data).find('#js_content_ajax'));
						},
						complete: function(){
							app_refresh.initialize();
							loader.hide();
						}
					});
				});
			} else {
				input.addClass('error').focus();
				input.popover({
					//title: 'Ошибка',
					content: 'Введите количество баллов',
					//container: '.js_coupon_form_group',
					placement: 'top',
					trigger: 'focus'
				});
				input.popover('show');
			}

		},

        orderApplyPromoCode: function(){

            var input = $('#js-shop-order__promo-code-input'),
                code = input.val(),
                loader = $('#js_overlay_loader');

            if(code){

                loader.show();

                $.ajax({
                    type: 'post',
                    url: '/core/ajax/promo_code_apply.php',
                    data: {
                        code: code
                    },
                    success: function (data, textStatus) {
                        if(textStatus==='success') {

                            if (data.success) {
                                $.ajax({
                                    type: 'get',
                                    url: '/katalog/order.html',
                                    success: function (data) {
                                        var content = $(data).find('#js_area');
                                        $('#js_area').replaceWith(content);
                                        app.resetDeliveryTypesInitialised();

                                        app_refresh.initialize();

                                        app.dataLayerPushCheckoutCart(2); // шаг 2 - Скидка
                                    },
                                    complete: function () {
                                        loader.hide();
                                    }
                                });
                            } else {
                                input.addClass('is-invalid');
                                input.parent().addClass('has-error');

                                $('#js-shop-order__discount-promo-code-hint').text(data.message);

                                loader.hide();
                            }

                        } else {
                            loader.hide();
                        }
                    },
                    error: function () {
                        input.addClass('is-invalid');
                        input.parent().addClass('has-error');

                        loader.hide();
                    },
                });

            } else {
                input.addClass('is-invalid').focus();
                input.parent().addClass('has-error');
            }

        },

		compareAddingItem: function(e){
			e.preventDefault();

			var THIS = $(this),
				item_id = THIS.val(),
				loader = $('#js_overlay_loader'),
				js_compare_module = $('#js_compare_module');

			loader.show();
			$.ajax({
				type: 'post',
				url: '/katalog/compare/'+item_id,
				//data: {target_id: item_id},
				dataType: 'json',
				success: function(data){
					if(!data.error){
						THIS.parent().addClass('js_is_compare');

						if(js_compare_module.length){
							var js_compare_count = js_compare_module.find('.js_compare_count');
							if(js_compare_count.length){
								var res_count = js_compare_count.html();
								res_count = +res_count + 1;
								js_compare_count.html(res_count);
							} else {
								js_compare_module.html('<a href="/katalog/compare.html" class="icon" title="Перейти к списку сравнения"><span class="js_compare_count">1</span></a>');
							}
						}
					}
				},
				complete: function(){
					//app_refresh.initialize();
					loader.hide();
				}
			});

		},

		compareDelItem: function(e){
			e.preventDefault();

			var THIS = $(this),
				item_id = THIS.val(),
				loader = $('#js_overlay_loader'),
				compare_view = $('#js_compare_page').length,
				js_compare_module = $('#js_compare_module');

			loader.show();
			$.ajax({
				type: 'post',
				url: '/katalog/compare/remove/'+item_id,
				//data: {target_id: item_id},
				dataType: 'json',
				success: function(data){
					if(!data.error){

						if(!compare_view) {
							THIS.parent().removeClass('js_is_compare');
						} else {
							$.ajax({
								type: 'get',
								url: '/katalog/compare.html',
								success: function (data) {
									var content = $(data).find('#js_content_ajax');
									$('#js_content_ajax').replaceWith(content);
								},
								complete: function(){
									app_refresh.initialize();
									loader.hide();
								}
							});
						}

						if(js_compare_module.length){
							var js_compare_count = js_compare_module.find('.js_compare_count');
							if(js_compare_count.length){
								var res_count = js_compare_count.html();

								if(res_count > 1){
									res_count = +res_count - 1;
									js_compare_count.html(res_count);
								} else {
									js_compare_module.html('<div class="icon" title="В списке сравнения пусто"></div>');
								}

							}
						}
					}
				},
				complete: function(){
					//app_refresh.initialize();
					if(!compare_view) {
						loader.hide();
					}
				}
			});

		},

		bookmarksAddItem: function(e){
			e.preventDefault();

			var THIS = $(this),
				item_id = THIS.val(),
				loader = $('#js_overlay_loader'),
				js_wishlist_module = $('#js_wishlist_module');

			loader.show();
			$.ajax({
				type: 'post',
				url: '/katalog/bookmarks/add.html',
				data: {target_id: item_id},
				dataType: 'json',
				success: function(data){
					if(!data.error){
						THIS.parent().addClass('js_is_bookmark');

						if(js_wishlist_module.length){
							js_wishlist_module.replaceWith(data.html);
						}
					}
				},
				complete: function(){
					//app_refresh.initialize();
					loader.hide();
				}
			});

		},

		bookmarksDelItem: function(e){
			e.preventDefault();

			var THIS = $(this),
				item_id = THIS.val(),
				loader = $('#js_overlay_loader'),
				bookmarks_view = $('#js_bookmarks_view').length,
				js_wishlist_module = $('#js_wishlist_module');

			loader.show();
			$.ajax({
				type: 'post',
				url: '/katalog/bookmarks/delete.html',
				data: {target_id: item_id},
				dataType: 'json',
				success: function(data){
					if(!data.error){

						if(!bookmarks_view) {
							THIS.parent().removeClass('js_is_bookmark');
						} else {
							$.ajax({
								type: 'get',
								url: '/katalog/bookmarks',
								success: function (data) {
									var content = $(data).find('#js_content_ajax');
									$('#js_content_ajax').replaceWith(content);
									loader.hide();
								}
							});
						}

						if(js_wishlist_module.length){
							js_wishlist_module.replaceWith(data.html);
						}

					}
				},
				complete: function(){
					//app_refresh.initialize();
					if(!bookmarks_view) {
						loader.hide();
					}
				}
			});
		},

		searchSmart: function(e){

			var INPUT = $(this),
				STRING = INPUT.val(),
                FORM = INPUT.closest('.js-search-form'),
                RESULT = FORM.find('.js-smart-result');
			if (STRING.length > 2) { // делаем запрос, если длина строки больше 2 символов

				if (typeof timeout_id !== "undefined") { //timeout_clear();
					clearTimeout(timeout_id);
				}

				timeout_id = setTimeout(function(){
					app.searchGetResults(INPUT,STRING);
				}, 300); //timeout_set();

			}
			if (STRING.length === 0) {

                RESULT.html('').hide();

			}
		},

		searchGetResults: function(INPUT,STRING){

            var FORM = INPUT.closest('.js-search-form'),
                RESULT = FORM.find('.js-smart-result');
			//INPUT.attr('readonly','readonly');
			STRING = STRING.replace(/ /gi, '+');

            RESULT.load('/katalog/shopsearch.html?squery='+STRING+'&smart=1', function(){

			    // console.log(this);

				$(this).show();


				$(document).mouseup(function (e){
					if (!RESULT.is(e.target) // если клик был не по нашему блоку
						&& RESULT.has(e.target).length === 0) { // и не по его дочерним элементам
                        RESULT.hide(); // скрываем его
					}
				});

				//INPUT.removeAttr('readonly');

			});

			return true;
		},

        quickOrderSubmit: function(e){
            e.preventDefault();
            var form = $(this),
                form_data = form.serialize(),
                loader = $('#js_overlay_loader');

            if(app.validateForm(form) === true) {

                loader.show();
                $('#js-shop-quick-order__sent, #js-shop-quick-order__error').addClass('hidden');

                $.ajax({
                    type: form.attr('method'),
                    url: form.attr('action'),
                    data: form_data,
                    success: function (data, textStatus) {
                        if(textStatus==='success' && data.success) {
                            $('#js-shop-quick-order__sent').removeClass('hidden');
                            form.hide();

                            app.dataLayerPushCheckout1Click(6); // шаг 6 - Завершение заказа в 1 клик

                            if(data.order) {
                                app.dataLayerPushPurchase(data.order); // отправка успешного оформления заказа
                            }

                            app.yandexCommerceSend();
							// app.googleCommerceSend();

                        } else if(data.message) {
                            $('#js-shop-quick-order__error').html(data.message).removeClass('hidden');
                        }

                    },
                    complete: function () {
                        loader.hide();
                    }
                });
            }
        },

		feedbackRating: function(e){
			e.preventDefault();
			var button = $(this),
					action = button.attr('name'),
					feedback_id = button.val(),
					feedback_value = $('span', button).html(),
					loader = $('#js_overlay_loader');

			loader.show();

			$.ajax({
				type: 'post',
				url: '/katalog/feedback/rating',
				data: {action: action, feedback_id: feedback_id},
				success: function (data, textStatus) {
					if(textStatus==='success' && data.success) {
						$('span', button).html(+feedback_value + 1);
					}
				},
				complete: function (data) {
					loader.hide();
					app_refresh.initialize();
				}
			});
		},

		feedbackAdd: function(e){
			e.preventDefault();
			var form = $(this),
                item_data = form.serialize(),
                loader = $('#js_overlay_loader');

            if(app.validateForm(form) === true) {

                loader.show();
                $('#js_feedback_sent, #js_feedback_error').addClass('hidden');

                $.ajax({
                    type: 'post',
                    url: '/katalog/feedback/add',
                    data: item_data,
                    success: function (data, textStatus) {
                        if(textStatus==='success' && data.success) {
                            $('#js_feedback_sent').removeClass('hidden');
                            form.hide();
                        } else if(data.message) {
                            $('#js_feedback_error').html(data.message).removeClass('hidden');
                        }

                    },
                    complete: function () {
                        loader.hide();
                        // app_refresh.initialize();
                    }
                });
            }
		},

        feedbackShopItemAdd: function(e){
			e.preventDefault();
			var form = $(this),
                item_data = form.serialize(),
                loader = $('#js_overlay_loader');

            if(app.validateForm(form) === true) {

                loader.show();
                $('#js_feedback_sent, #js_feedback_error').addClass('hidden');

                $.ajax({
                    type: 'post',
                    url: '/katalog/feedback/add',
                    data: item_data,
                    success: function (data, textStatus) {
                        if(textStatus==='success' && data.success) {
                            $('#js_feedback_sent').removeClass('hidden');
                            form.hide();
                        } else if(data.message) {
                            $('#js_feedback_error').html(data.message).removeClass('hidden');
                        }

                    },
                    complete: function () {
                        loader.hide();
                        // app_refresh.initialize();
                    }
                });
            }
		},

        setFeedbacksVisible: function(){

            var feedback_tab = $('#feedback-tab');

            if (feedback_tab.length) {

                feedback_tab.on('shown.bs.tab', function () {
                    app.anchorLinkMove('#shop-item-page_tab-content');

                    feedback_tab.off('shown.bs.tab');
                })

                feedback_tab.tab('show');

            } else {
                var collapse = $('#collapseTwo');

                collapse.on('shown.bs.collapse', function () {
                    app.anchorLinkMove('#collapseTwo');

                    collapse.off('shown.bs.collapse');
                })

                collapse.collapse('show');
            }

		},

		orderCommentAdd: function(e){
			e.preventDefault();
			var form = $(this),
                form_data = form.serialize(),
                loader = $('#js_overlay_loader'),
                alertError = $('#js-order-comment-error');

            if(app.validateForm(form) === false) {
                return false;
            }

            loader.show();

            alertError.addClass('hidden');

            $.ajax({
                type: 'post',
                url: '/core/ajax/order_comment_add.php',
                data: form_data,
                success: function (data, textStatus) {
                    if(textStatus==='success' && data.success) {
                        $('#order-comments__list').replaceWith(data.html);
                    } else if(data.message) {
                        alertError.html(data.message).removeClass('hidden');
                    }
                    form[0].reset();

                },
                complete: function () {
                    loader.hide();
                }
            });
		},

		subscribeAdd: function(e){
			e.preventDefault();
			var form = $(this),
				item_data = form.serialize(),
				loader = $('#js_overlay_loader');

            if(app.validateForm(form) === false) {
                return false;
            }

			loader.show();
			$('#js_subscribe_sent, #js_subscribe_error').addClass('hidden');

			$.ajax({
				type: 'post',
				url: '/katalog/subscribe/add',
				data: item_data,
                success: function (data, textStatus) {
                    if(textStatus==='success' && data.success) {
						$('#js_subscribe_sent').removeClass('hidden');
					} else {
						if(data.email_is_subscriber) {
							$('#js_subscribe_error').html('Ваш E-mail уже есть в базе подписчиков').removeClass('hidden');
						}
						if(data.email_empty) {
							$('#js_subscribe_error').html('Не указан E-mail').removeClass('hidden');
						}
					}
					form.hide();
				},
				complete: function (data) {
					loader.hide();
					app_refresh.initialize();
				}
			});
		},

		realdiscountcardSave: function(e){
			e.preventDefault();
			var form = $(this),
                item_data = form.serialize(),
                user_id = form.find('#user_id').val(),
				loader = $('#js_overlay_loader'),
                input = $('#js-discount-card'),
                btn = form.find('[type=submit]');

            if(app.validateForm(form) !== true) {
                return false;
            }

			// loader.show();

            // btn.prop('disabled', true);
            btn.addClass('btn-sending');
            btn.text(btn.attr('data-sending-text'));

			$.ajax({
				// type: 'post',
				// url: '/users/'+user_id+'/discontcard/save',
                type: 'post',
                url: '/core/ajax/discount_card_save.php',
				data: item_data,
				success: function (data, textStatus) {
                    if(textStatus==='success' && data.success) {

                        $.ajax({
                            type: 'get',
                            url: '/users/'+user_id,
                            success: function (data) {
                                var content = $(data).find('#js_area');
                                $('#js_area').replaceWith(content);
                                app_refresh.initialize();
                            },
                            complete: function () {
                                btn.removeClass('btn-sending');
                                btn.text(btn.attr('data-normal-text'));
                            }
                        });

                    } else {
                        input.addClass('is-invalid');
                        input.parent().addClass('has-error').removeClass('has-success');

                        // loader.hide();
                        btn.removeClass('btn-sending');
                        btn.text(btn.attr('data-normal-text'));
                    }

				},
				error: function () {
					// loader.hide();
                    btn.removeClass('btn-sending');
                    btn.text(btn.attr('data-normal-text'));
				}
			});
		},

        orderSaveDiscountCardClick: function(e){
			e.preventDefault();
			var loader = $('#js_overlay_loader');

            var input = $('#js-shop-order__discount-card-input'),
                card = input.val();

			loader.show();

			$.ajax({
				type: 'post',
				url: '/core/ajax/discount_card_save.php',
				data: {
				    card: card
                },
                success: function (data, textStatus) {
                    if(textStatus==='success' && data.success) {

                        $.ajax({
                            type: 'get',
                            url: '/katalog/order.html',
                            success: function (data) {
                                var content = $(data).find('#js_area');
                                $('#js_area').replaceWith(content);
                                app.resetDeliveryTypesInitialised();
                                app_refresh.initialize();

                            },
                            complete: function () {
                                loader.hide();
                            }
                        });

                        app.dataLayerPushCheckoutCart(2); // шаг 2 - Скидка

                    } else {
                        input.addClass('is-invalid');
                        input.parent().addClass('has-error');
                        loader.hide();
                    }
                },
                error: function () {
                    loader.hide();
                }
			});
		},

		changeSelectDocs: function(e) {
			var select = $(this),
				cat_id = select.val(),
				form   = select.closest('form'),
				next   = form.find('.js_subcat_2'),
				url    = '/content/get_subcats',
				loader = $('#js_overlay_loader')
				;

			loader.show();
			//select.attr('readonly', 'readonly');
			$.ajax({
				type: 'get',
				dataType: 'json',
				url: url,
				data: {cat_id: cat_id},
				success: function(data) {
					next.replaceWith(data.html);
				},
				complete: function () {
					loader.hide();
					//select.removeAttr('readonly');
				}
			});
		},

		ajaxLinks: function(e){
			e.preventDefault();

			var url = $(this).attr('href'),
					loader = $('#js_overlay_loader');

			loader.show();
			$.ajax({
				type: 'get',
				url: url,
				success: function (data) {
					var content = $(data).find('#js_area');
					$('#js_area').replaceWith(content);

					$('html, body').animate({
						scrollTop: $("#js_area").offset().top
					}, 500);

					history.pushState('', '', url);
				},
				complete: function(){
					app_refresh.initialize();
					loader.hide();
				}
			});

		},

        anchorLinkClick: function(e){
			e.preventDefault();

			var anchor = $(this).attr('href'),
            focusOn = $(this).attr('data-focus-on');

            app.anchorLinkMove(anchor, focusOn);

		},

        anchorLinkMove: function(anchor, focusOn) {
		    var target = $(anchor),
                navbarFixedHeight = 0;

            if ( !target.is(':visible') || !target.length ) {
                return false;
            }

            if ( $(window).width() < 1000 ) {
                navbarFixedHeight = $('#js-navbar').outerHeight()
            }

            var offset = navbarFixedHeight + 10;

            $('html, body').animate({
                scrollTop: target.offset().top - offset
            }, 500);

            if(focusOn) {
                $(focusOn).focus();
            }
        },

        feedbackFormToggleBtnClick: function(e){
			e.preventDefault();

			app.feedbackFormToggle();

		},

        feedbackFormToggle: function(){

			if ( $(window).width() < 768 ) {

                var btn = $('#js-feedback-form-toggle-btn'),
                    form = $('#js_feedback_add');

                btn.hide();
                form.show();

            }

		},

        courierMapInit: function () {


        },
	};

	app.initialize();

	app_refresh.initialize();

    // if( typeof ymaps !== 'undefined') {
    //     ymaps.ready(app.courierMapInit);
    // }

    app.clickOnFirstDeliveryType();

    //zakl.js

	function orderMovieBy(orderby, login){
		$('.tabSearch').css('background', 'url(/templates/itp/images/ajax-loader.gif) no-repeat  scroll right 5px transparent');
		$.post('/bookmarks/'+login, {'of_ajax': 1, orderby: orderby}, function(data){
			$('div.component').html(data);
		});
	}
	function orderMovieTo(orderto, login){
		$('.tabSearch').css('background', 'url(/templates/itp/images/ajax-loader.gif) no-repeat  scroll right 5px transparent');
		$.post('/bookmarks/'+login, {'of_ajax': 1, orderto: orderto}, function(data){
			$('div.component').html(data);
		});
	}
	//zakl.js - конец


	if(typeof wpfront_scroll_top == "function") wpfront_scroll_top({"scroll_offset":300,"button_opacity":1,"button_fade_duration":200,"scroll_duration":400,"hide_iframe":false,"auto_hide":true,"auto_hide_after":2});

    if ( $("#region_title").length ) { // автозавершение региона в личном кабинете
        $("#region_title").autocomplete({
                source: "/core/ajax/regionsearch.php",
                autoFocus: false,
                multiple: false,
//                    focus: function( event, ui ) {
//                        $( "#region_title" ).val( ui.item.title );
//                        return false;
//                    },
                select: function( event, ui ) {
                    $( "#region_title" ).val( ui.item.title );
                    $( "#region_id" ).val( ui.item.id );
                    return false;
                }
            })
            .autocomplete( "instance" )._renderItem = function( ul, item ) {
            return $( "<li>" )
                .append( "<div>" + item.title + "</div>" )
                .appendTo( ul );
        };
    }

    if ( $("#customer_address_region_title").length ) { // автозавершение региона в оформлении заказа
        $("#customer_address_region_title").autocomplete({
                source: "/core/ajax/regionsearch.php",
                autoFocus: false,
                multiple: false,
//                    focus: function( event, ui ) {
//                        $( "#customer_address_region_title" ).val( ui.item.title );
//                        return false;
//                    },
                select: function( event, ui ) {
                    var region_title = $('#customer_address_region_title'),
                        region_id = $('#customer_address_region_id'),
                        form_group = region_title.closest('.form-group');
                    region_title.val( ui.item.title );
                    region_id.val( ui.item.id );
                    form_group.removeClass('has-error');
                    return false;
                }
            })
            .autocomplete( "instance" )._renderItem = function( ul, item ) {
            return $( "<li>" )
                .append( "<div>" + item.title + "</div>" )
                .appendTo( ul );
        };

        $(document).on('keypress', '#customer_address_region_title', function(){
            var region_id = $('#customer_address_region_id'),
                form_group = $(this).closest('.form-group');

            region_id.val('');
            form_group.removeClass('has-error');
        });

        $(document).on('blur', '#customer_address_region_title', function(){
            var region_id = $('#customer_address_region_id'),
                form_group = $(this).closest('.form-group');

            if ( !region_id.val() ) {
                $(this).val('');
                form_group.addClass('has-error');
            }
        });
    }

//     if ( $("#city").length ) { // автозавершение города в личном кабинете
//         $("#city").autocomplete({
//                 source: "/core/ajax/citysearch.php",
//                 autoFocus: false,
//                 multiple: false,
// //                    focus: function( event, ui ) {
// //                        $( "#city" ).val( ui.item.title );
// //                        return false;
// //                    },
//                 select: function( event, ui ) {
//                     $( "#city" ).val( ui.item.title );
//                     return false;
//                 }
//             })
//             .autocomplete( "instance" )._renderItem = function( ul, item ) {
//             return $( "<li>" )
//                 .append( "<div>" + item.title + "</div>" )
//                 .appendTo( ul );
//         };
//     }
//
//     if ( $("#customer_address_city").length ) { // автозавершение города в оформлении заказа
//         $("#customer_address_city").autocomplete({
//                 source: "/core/ajax/citysearch.php",
//                 autoFocus: false,
//                 multiple: false,
// //                    focus: function( event, ui ) {
// //                        $( "#customer_address_city" ).val( ui.item.title );
// //                        return false;
// //                    },
//                 select: function( event, ui ) {
//                     $( "#customer_address_city" ).val( ui.item.title );
//                     return false;
//                 }
//             })
//             .autocomplete( "instance" )._renderItem = function( ul, item ) {
//             return $( "<li>" )
//                 .append( "<div>" + item.title + "</div>" )
//                 .appendTo( ul );
//         };
//     }

});


window.addEventListener("popstate", function(e) {
	// Передаем текущий URL
	getContent(window.location.href, false);
});

// Функция загрузки контента
function getContent(url, addEntry) {

	var loader =  jQuery('#js_overlay_loader');
	if(loader.length){
		loader.show();
	}

	url = url.replace(/http:\/\//g, "//");
	url = url.replace(/https:\/\//g, "//");

	jQuery.ajax({
		type: 'get',
		url: url,
		//headers: { "X-Requested-With":"NULL" }, //для icms2 нужно
		success: function (data) {
			var content = jQuery(data).find('#js_area');
			jQuery('#js_area').replaceWith(content);

			//var title = document.getElementById('doc_title').value;
			//document.title = title;

			jQuery('html, body').animate({
				scrollTop: jQuery("#js_area").offset().top
			}, 500);
		},
		error: function(){
			location=url;
		},
		complete: function(){

			if(loader.length){
				loader.hide();
			}

			app_refresh.initialize();

			if(addEntry == true) {
				history.pushState(null, null, url);
			}
		}
	});

	//jQuery('#js_content_ajax').load(url + " #js_content_ajax", function(){
	//
	//	if(loader.length){
	//		loader.hide();
	//	}
	//
	//	if(addEntry == true) {
	//		history.pushState(null, null, url);
	//	}
	//});


}

var app_refresh = {

	initialize: function () {
		this.setUpListners();
	},

	setUpListners: function () {

        $("[data-fancybox]").fancybox({
            image : {
                protect: true
            }
        });

        // $(function () {
        //     $('[data-toggle="popover"]').popover()
        // })

        $(".js-stocks-popover").popover({
            trigger: "manual",
            html: true,
            animation: false
        }).on("mouseenter", function() {
            var _this = this;
            $(this).popover("show");
            $(".popover").on("mouseleave", function() {
                $(_this).popover('hide');
            });
        }).on("mouseleave", function() {
            var _this = this;
            setTimeout(function() {
                if (!$(".popover:hover").length) {
                    $(_this).popover("hide");
                }
            }, 300);
        });

		var mycontainer = "article";
		jQuery(mycontainer+" a[href$='.png'],"+mycontainer+" a[href$='.PNG'],"+mycontainer+" a[href$='.jpg'],"+mycontainer+" a[href$='.JPG'], "+mycontainer+" a[href$='.jpeg'],"+mycontainer+" a[href$='.JPEG'],"+mycontainer+" a[href$='.gif'],"+mycontainer+" a[href$='.GIF'], "+mycontainer+" a[href$='.bmp'],"+mycontainer+" a[href$='.BMP']").attr("data-fancybox","article-fancybox").fancybox({
			image : {
				protect: true
			}
		});

		jQuery("a.fancy").fancybox({
			image : {
				protect: true
			}
		});

		// чтобы при наведении на регион на карте
        // регион становился выше других (это вместо z-index)
		var geographySVG = $('#js-about-page__geography-svg'),
            paths = geographySVG.find('.region-honey');
        var i = paths.length;
        while(i--) {
            // console.log(paths[i]);
            paths[i].addEventListener("mouseenter", function(e) {
                geographySVG[0].appendChild(e.target);
            });
        }

        /*MASKED INPUT START*/
        $('input[type=tel], input.js_phone_input')
            .mask(
                "+7 999 999 99 99",
                {
                    placeholder: " ",
                    is_phone: true
                    // completed: function(){
                    //     console.log('completed', this.val());
                    // }
                }
            );

        $('#js-discount-card').mask("9999 9999? 99999");
        $('#js-shop-order__discount-card-input').mask("9999 9999? 99999");

		if(jQuery(".filter-body .slider-range").length) {

			jQuery(".filter-body .slider-range").each(function(indx, element){

				var CUR_SLIDER = jQuery(element),
						CUR_SLIDER_BLOCK = CUR_SLIDER.closest('.js_slider_range_block'),

						MIN_ELEM = CUR_SLIDER_BLOCK.find('.js_slider_range_cur_min'),
						MIN = +MIN_ELEM.attr('data-min-value'),
						CUR_MIN = +MIN_ELEM.attr('data-value'),

						MAX_ELEM = CUR_SLIDER_BLOCK.find('.js_slider_range_cur_max'),
						MAX = +MAX_ELEM.attr('data-max-value'),
						CUR_MAX = +MAX_ELEM.attr('data-value'),

						STEP = +CUR_SLIDER.attr('data-step');

				if(CUR_SLIDER.is('#js_slider_range_price')){
					STEP = 1;
				}

				CUR_SLIDER.slider({
					range: true,
					step: STEP,
					min: MIN,
					max: MAX,
					values: [CUR_MIN, CUR_MAX],
					slide: function (event, ui) {
						if(ui.values[0] != MIN) {
							MIN_ELEM.val(ui.values[0]);
						} else {
							MIN_ELEM.val('');
						}

						if(ui.values[1] != MAX) {
							MAX_ELEM.val(ui.values[1]);
						} else {
							MAX_ELEM.val('');
						}
					},
					stop: function(event, ui) {

						/* floatsubmit */
						var label = jQuery(this).parent(),
								otstup = label.position(),
								floatsubmit = jQuery("#js_floatsubmit");

						otstup.top = otstup.top - 5;
						floatsubmit.css("top", otstup.top + "px").show();

					}
				});

			});


			jQuery(".filter-body.js_slider_range_block").find('.js_slider_range_cur_min').change(function(){
				var MIN_ELEM = jQuery(this),
						CUR_SLIDER_BLOCK = jQuery(this).closest('.js_slider_range_block'),
						CUR_SLIDER = CUR_SLIDER_BLOCK.find('.slider-range'),
						MAX_ELEM = CUR_SLIDER_BLOCK.find('.js_slider_range_cur_max'),

						CUR_MIN = MIN_ELEM.attr('data-value'),
						MIN = +MIN_ELEM.attr('data-min-value'),

						CUR_MAX = MAX_ELEM.attr('data-value'),
						MAX = +MAX_ELEM.attr('data-max-value');

				var value1=+MIN_ELEM.val()||CUR_MIN;
				var value2=+MAX_ELEM.val()||CUR_MAX;
				if(value1 > value2){value1 = value2};
				if(value1 < MIN){value1 = MIN};

				if(value1 <= MIN){ MIN_ELEM.val(''); }
				else { MIN_ELEM.val(value1); }

				CUR_SLIDER.slider("values",0,value1);
			});

			jQuery(".filter-body.js_slider_range_block").find('.js_slider_range_cur_max').change(function(){
				var MAX_ELEM = jQuery(this),
						CUR_SLIDER_BLOCK = jQuery(this).closest('.js_slider_range_block'),
						CUR_SLIDER = CUR_SLIDER_BLOCK.find('.slider-range'),
						MIN_ELEM = CUR_SLIDER_BLOCK.find('.js_slider_range_cur_min'),

						CUR_MIN = MIN_ELEM.attr('data-value'),
						MIN = +MIN_ELEM.attr('data-min-value'),

						CUR_MAX = MAX_ELEM.attr('data-value'),
						MAX = +MAX_ELEM.attr('data-max-value');

				var value1=+MIN_ELEM.val()||CUR_MIN;
				var value2=+MAX_ELEM.val()||CUR_MAX;
				if (value2 > MAX) { value2 = MAX};
				if(value1 > value2){value2 = value1;}

				if(value2 >= MAX){ MAX_ELEM.val(''); }
				else { MAX_ELEM.val(value2); }

				CUR_SLIDER.slider("values",1,value2);
			});


		}


		/*SLICK SLIDER START*/

		// var ITEM_IMAGE = jQuery('.shop-item-page__image > .image'),
		// 	IMAGES = jQuery('.shop-item-page__images .image');
		// if(ITEM_IMAGE.length && ITEM_IMAGE.not('.slick-initialized').length && IMAGES.length > 1) {
		// 	jQuery('.shop-item-page__image').slick({
		// 		slidesToShow: 1,
		// 		slidesToScroll: 1,
		// 		autoplay: false,
		// 		autoplaySpeed: 2000,
		// 		arrows: false,
		// 		fade: true,
		// 		asNavFor: '.shop-item-page__images .row'
		// 	});
		// 	jQuery('.shop-item-page__images .row').slick({
		// 		slidesToShow: 5,
		// 		slidesToScroll: 1,
		// 		asNavFor: '.shop-item-page__image',
		// 		dots: false,
		// 		centerMode: true,
		// 		focusOnSelect: true,
		// 		centerPadding: 0,
		// 		arrows: false,
		// 		// prevArrow: jQuery('.shop-item-page__images .slide-prev'),
		// 		// nextArrow: jQuery('.shop-item-page__images .slide-next')
		// 	});
        //
		// }

		var bottom_slider_main = $('.bottom-slider__slides'),
            bottom_slider_thumbs = $('.bottom-slider__thumbs'),
            bottom_slider_thumbs_length = $('.bottom-slider__thumb').length,
            bottom_slider_slides_to_show;

		// определяем slides_to_show, оно должно быть нечетным и меньше, чем есть слайдов
        bottom_slider_slides_to_show = bottom_slider_thumbs_length % 2 === 0 ? bottom_slider_thumbs_length-1 : bottom_slider_thumbs_length-2;

        // минимум 3
        bottom_slider_slides_to_show = bottom_slider_slides_to_show > 3 ? bottom_slider_slides_to_show : 3;
        // максимум 7
        bottom_slider_slides_to_show = bottom_slider_slides_to_show < 7 ? bottom_slider_slides_to_show : 7;
        // прописываем соответствующий класс с модификатором, чтобы задать правильную ширину контейнера миниатюр
        bottom_slider_thumbs.addClass('bottom-slider__thumbs_slides-to-show_'+bottom_slider_slides_to_show);

		if(bottom_slider_main.length && bottom_slider_main.not('.slick-initialized').length) {
            bottom_slider_main.slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: false,
				autoplaySpeed: 2000,
				arrows: true,
                dots: false,
				fade: true,
				asNavFor: '.bottom-slider__thumbs',
                prevArrow: $('.bottom-slider__main .slide-prev'),
                nextArrow: $('.bottom-slider__main .slide-next'),
                pauseOnHover: false,
                pauseOnFocus: false,
			});
            bottom_slider_thumbs.slick({
				slidesToShow: bottom_slider_slides_to_show,
				slidesToScroll: 1,
				asNavFor: '.bottom-slider__slides',
				dots: false,
				centerMode: true,
				focusOnSelect: true,
				centerPadding: 0,
				arrows: false,
                pauseOnHover: false,
                pauseOnFocus: false,
			});

		}
		$('.js_bottom-slider__play').on('click', function () {
            var bottomSlickObject = bottom_slider_main.slick('getSlick');

            if (bottomSlickObject.paused) {
                bottom_slider_main.slick('slickPlay');
                bottom_slider_main.slick('slickNext');
            } else {
                bottom_slider_main.slick('slickPause');
            }
        });

		var MAIN_SLIDER = $('.main-slider > .slides');
		if(MAIN_SLIDER.length && MAIN_SLIDER.not('.slick-initialized').length) {
			MAIN_SLIDER.slick({
				autoplay: false,
				autoplaySpeed: 3000,
				slidesToScroll: 1,
				slidesToShow: 1,
				dots: false,
				arrows: true,
				prevArrow: $('.main-slider .slide-prev'),
				nextArrow: $('.main-slider .slide-next')
			});
		}

		var sliderStore = $('#js-shop-store-slider');
		if(sliderStore.length && $('.slide', sliderStore).length && sliderStore.not('.slick-initialized').length) {
            sliderStore.slick({
				autoplay: false,
				autoplaySpeed: 3000,
				slidesToScroll: 1,
				slidesToShow: 1,
				dots: false,
				arrows: true,
				prevArrow: $('#js-shop-store-slider-wrapper .slide-prev'),
				nextArrow: $('#js-shop-store-slider-wrapper .slide-next')
			});
		}

		var COMPANIES_SLIDER = $('.companies-slider > .slides');
		if(COMPANIES_SLIDER.length && COMPANIES_SLIDER.not('.slick-initialized').length) {
            COMPANIES_SLIDER.slick({
				autoplay: true,
				autoplaySpeed: 3000,
				slidesToScroll: 1,
				slidesToShow: 1,
				dots: true,
				arrows: true,
                dotsClass: '',
                customPaging: function(i) {return '<span></span>'},
				appendDots: $('.companies-slider .slider-dots-container'),
				prevArrow: $('.companies-slider .slide-prev'),
				nextArrow: $('.companies-slider .slide-next')
			});
		}

		var sliderHits = $('.shop-hits-list-items > .row');
		if(sliderHits.length && $('.shop-hits-list-item', sliderHits).length > 5 && sliderHits.not('.slick-initialized').length) {
            sliderHits.slick({
				// autoplay: true,
				autoplaySpeed: 500,
				slidesToScroll: 3,
				slidesToShow: 5,
                slide: ".shop-hits-list-item",
                rows: 0,
				dots: false,
				arrows: true,
				prevArrow: $('.slide-prev', sliderHits),
				nextArrow: $('.slide-next', sliderHits)
			});
		}

		// var sliderStore = $('#shop-store__photos-slider');
		// if(sliderStore.length && $('.shop-store__photo-slide', sliderStore).length && sliderStore.not('.slick-initialized').length) {
        //     sliderStore.slick({
        //         speed: 1000,
		// 		autoplay: true,
		// 		autoplaySpeed: 3000,
		// 		slidesToScroll: 4,
		// 		slidesToShow: 4,
        //         slide: ".shop-store__photo-slide",
        //         rows: 0,
		// 		dots: false,
		// 		arrows: true,
		// 		prevArrow: $('.slide-prev', sliderStore),
		// 		nextArrow: $('.slide-next', sliderStore),
        //         responsive: [
        //             {
        //                 breakpoint: 1000,
        //                 settings: {
        //                     speed: 750,
        //                     slidesToScroll: 3,
        //                     slidesToShow: 3,
        //                 }
        //             },
        //             {
        //                 breakpoint: 768,
        //                 settings: {
        //                     speed: 250,
        //                     slidesToScroll: 1,
        //                     slidesToShow: 1,
        //                 }
        //             }
        //         ]
		// 	});
		// }

		var BRANDS_CAROUSEL = jQuery('.brands-carousel .brands-list > .row');
		if(BRANDS_CAROUSEL.length && BRANDS_CAROUSEL.not('.slick-initialized').length) {
			BRANDS_CAROUSEL.slick({
				slidesToScroll: 1,
				slidesToShow: 5,
				lazyLoad: 'ondemand',
				dots: false,
				arrows: true,
				prevArrow: jQuery('.brands-list .slide-prev'),
				nextArrow: jQuery('.brands-list .slide-next'),
				draggable: true
			});
		}

		var RECENT_ITEMS = jQuery('.recent-items > .shop_items_list > .row');
		if(jQuery('.shop-item', RECENT_ITEMS).length > 4 && RECENT_ITEMS.not('.slick-initialized').length) {
			RECENT_ITEMS.slick({
				slidesToScroll: 1,
				slidesToShow: 3,
				dots: false,
				arrows: true,
				prevArrow: jQuery('.recent .slide-prev'),
				nextArrow: jQuery('.recent .slide-next'),
				responsive: [
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 2
						}
					}
				]
			});
		}

		var SIMILAR_ITEMS = jQuery('.similar-items > .shop_items_list > .row');
		if(jQuery('.shop-item', SIMILAR_ITEMS).length > 4 && SIMILAR_ITEMS.not('.slick-initialized').length) {
			SIMILAR_ITEMS.slick({
				slidesToScroll: 1,
				slidesToShow: 3,
				dots: false,
				arrows: true,
				prevArrow: jQuery('.related-prev'),
				nextArrow: jQuery('.related-next'),
				responsive: [
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 2
						}
					}
				]
			});
		}

		/*SLICK SLIDER END*/


	}
}


//Функция для модуля поиска
function toggleInput(id){
	$('#from_search label#'+id).toggleClass('selected');
}

//функции голосования
function pollSubmit(){
    $('#mod_poll_submit').attr('disabled', 'disabled');
    var options = {
        success: loadPoll
    };
    $('#mod_poll_submit_form').ajaxSubmit(options);
}
function loadPoll(result, statusText, xhr, $form){
    var module_id = $('#mod_polls_module_id').attr('value');
	if(statusText == 'success'){
		if(result.error == false){
            core.alert(result.text, 'Уведомление!');
            $.post('/modules/mod_polls/load.php', {module_id: module_id, is_ajax: 1}, function(data){
                $('#poll_module_'+module_id).html(data);
            });
            setTimeout('core.box_close()', 900);
		} else {
            core.alert(result.text, 'Внимание!');
            $('#mod_poll_submit').attr('disabled', '');
        }
	}

}


//rew_comments.js - отзывы на странице товара
function addRew(sess_md5, target, target_id, parent_id){
	$('div.reply').html('').hide();
	$("#rew_addentry"+parent_id).html("<div>Загрузка формы...</div>");
	$("#rew_addentry"+parent_id).load("/components/rew/addform.php", {cd: sess_md5, target: target, target_id: target_id, parent_id: parent_id}, cmLoaded());
	$("#rew_addentry"+parent_id).slideDown("fast");
}

function editRew(sess_md5, comment_id){
	$('div.reply').html('').hide();
	var entry = $("#rew_addentry"+comment_id);
	entry.parent('div').find('.rew_entry').hide();
	entry.show();
	entry.html("<div>Загрузка формы...</div>");
	entry.load("/components/rew/addform.php", {cd: sess_md5, action: 'edit', id: comment_id}, cmLoaded());
}

function cmLoaded() {
	//$("#content").autogrow();
}

function cancelRew(parent_id){
	$("#rew_addentry"+parent_id).parent('div').find('.rew_entry').show();
	$("#rew_addentry"+parent_id).hide();
}

function expandRew(id){
	$('a#expandlink'+id).hide();
	$('div#expandblock'+id).show();
}

function addSmile(tag, field_id){
	var txtarea = document.getElementById(field_id);
	txtarea.value += ' :' + tag + ': ';
	$('#smilespanel').hide();
}

function loadRews(target, target_id, anchor){

	$('div.rew_ajax_list').html('<p style="margin:30px; margin-left:0px; padding-left:50px; background:url(/images/ajax-loader.gif) no-repeat">загрузка отзывов...</p>');

	$.ajax({
			type: "POST",
			url: "/components/rew/comments.php",
			data: "target="+target+"&target_id="+target_id,
			success: function(data){
				$('div.rew_ajax_list').html(data);
				$('td.loading').html('');
				if (anchor){
					window.location.hash = anchor.substr(1, 100);
					$('a[href='+anchor+']').css('color', 'red').attr('title', 'Вы пришли на страницу по этой ссылке');
				}
			}
	});

}

function goPage(dir, field, target, target_id){

	var p = Number($('#'+field).attr('value')) + dir;
	loadComments(target, target_id, p);

}

function voteRew(comment_id, vote){

	$('span#votes'+comment_id).html('<img src="/images/ajax-loader.gif" border="0"/>');
	$.ajax({
			type: "POST",
			url: "/components/rew/vote.php",
			data: "comment_id="+comment_id+"&vote="+vote,
			success: function(data){
				$('span#votes'+comment_id).html(data);
			}
	});

}

//rew_comments.js - отзывы на странице товара - конец

function floatBlockSB(FIXEDBLOCK){
	var offset = $(FIXEDBLOCK).offset();
	var bodyheight = $("#container").height();
	var topPadding = 30;
	var currentposition = 0;

	var blockposition = $(FIXEDBLOCK).position();
	var sidebarheight = $(FIXEDBLOCK).parent().height();
	var blockheight = sidebarheight - blockposition.top;

	$(window).scroll(function() {
	var scrolltopfunct = $(window).scrollTop();
		if (scrolltopfunct > (offset.top - topPadding)) {
			if(scrolltopfunct + topPadding + blockheight >= bodyheight){
				$(FIXEDBLOCK).stop().css({marginTop: currentposition});
			}
			else
			{
				$(FIXEDBLOCK).stop().css({marginTop: scrolltopfunct - offset.top + topPadding});
				currentposition = scrolltopfunct - offset.top + topPadding;
			}
		}
		else {$(FIXEDBLOCK).stop().css({marginTop: 0});};
	});
}

function pickpoint_result(result) {
	$("#js_pickpoint_text").html(result["name"] + "<br>" + result["address"]);
	$("#js_pickpoint").attr("value", result["name"] + " " + result["address"]);
}
function pickpoint_clear() {
	$("#js_pickpoint_text").html('');
	$("#js_pickpoint").attr("value", '');
}

function contactform_file_upload(){ // функция обработки input[type="file"]
	var file_upload = $(".file_upload"),
		inp = file_upload.find('input[type="file"]'),
		btn = file_upload.find(".file_btn"),
		lbl = file_upload.find(".file_name");

	inp.on('focus', function () {
		file_upload.addClass( "focus" );
	});
	inp.on('blur', function () {
		file_upload.removeClass( "focus" );
	});

	var file_api = ( window.File && window.FileReader && window.FileList && window.Blob ) ? true : false;
	inp.on('change', function () {
		var file_name = '';
		if( file_api && inp[0].files[0] ) {
			if (inp[0].files.length > 1) {
				$(inp[0].files).each(function(indx, element) {
					if ( file_name ) file_name += ', ';
					file_name += element.name;
				});
			} else {
				file_name = inp[0].files[0].name;
			}
		} else {
			file_name = inp.val().replace( "C:\\fakepath\\", '' );
		}

		if( ! file_name.length ) return;

		//if( lbl.is( ":visible" ) ){
		lbl.text( file_name );
		//btn.text( "Выбрать" );
		//}else
		//	btn.text( file_name );
	});

	inp.change();
}

function setCookieMy(name, value, seconds, domain) {
    var expires;
    if (seconds) {
        var date = new Date();
        date.setTime(date.getTime()+(seconds*1000));
        expires = "; expires="+date.toGMTString();
    }
    else {
        expires = "";
    }

    domain = "; domain="+ (domain ? domain : window.location.host);

    document.cookie = "CMS["+name+"]="+encodeURIComponent(value)+expires+"; path=/"+domain;

    if ( getCookieMy(name) === value ) {
        return value;
    } else {
        return false;
    }
}

function getCookieMy(name) {
    name = "CMS["+name+"]";
    var matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1].replace(/\+/g, '%20')) : undefined;
}
